<template>
  <TransactionTemplate
    :screenJson="getScreenJson"
    :headerScreenJson="getHeaderScreenJson"
    :setLoading="setLoading"
    :localDataGrid="false"
    :backButtonRoute="backButtonRoute"
    ref="supplier-invoice"
    :data-model="getDataModel"
    :isLoaded="loaded"
    v-if="!reload"
    :validationSummary="validationSummary"
    :gcPopupConfig="gcPopupConfig"
    :serverError="serverError"
    :warningSummary="warningSummary"
    :refreshColumns="refreshColumns"
    :linkAnItem="linkAnItem"
    :paging="false"
    :dxScrolling="'standard'"
  >
    <gcPopupSupInvFiles
      :visible="VisibleAttachmentPopup"
      @close="VisibleAttachmentPopup = false"
      @saveImage="saveImageToFiles"
      :baseView="baseView"
      v-if="VisibleAttachmentPopup"
      :allAttachements="Attachements"
      :transactionRecordIDProp="transactionRecordId"
      @showLoading="setLoading = $event"
      @getAttachedFiles="getAttachedFiles"
      @showServerError="serverError = $event"
    />

    <template #popup>
      <gcPopupInvoiceBalanceHistory
        :visible.sync="showHistory"
        :invoiceNumber="baseView.id"
        :customerNumber="customerCode"
        :InvoicedAmount="InvoicedAmount"
        :CurrencyCode="getCurrencyCode"
        :InvoiceType="'Supplier'"
        v-if="showHistory"
      />
    </template>
  </TransactionTemplate>
</template>

<script>
import TransactionTemplate from "../../templates/transaction";
import RouteMixin from "@/_mixins/route.mixin";
import FormMixin from "@/_mixins/form.mixin";
import { SupplierInvoiceService } from "../../_services/api/purchasing/supplier-invoice.service";
import { getDefaultUserSettings, getFactorByCode } from "../../_store/helpers";
import { PurchaseOrder } from "../../_services/api/purchasing/purchase-order.service";
import CheckBox from "devextreme/ui/check_box";
import { mapGetters } from "vuex";
import { SupplierInvoiceDetailsService } from "../../_services/api/purchasing/supplier-invoice-details.service";
import { DivisionService } from "../../_services/api/sales/division.service";
import { BranchService } from "../../_services/api/sales/branch.service";
import { TaxCategoryService } from "../../_services/api/settings/accounting/tax-category.service";
import { SupplierService } from "../../_services/api/suppliers/supplier.service";
import { CompanyCurrencyService } from "../../_services/api/accounts/company-currency.service";
import { CompanyService } from "../../_services/api/accounts/company.service";
import { FeatureStorage } from "../../_services/storage";
import { ProductService } from "../../_services/api/products/product.service";
import ArrayStore from "devextreme/data/array_store";
import ColumnWidth from "../../_helpers/data-grid/ColumnWidth";
import { alert } from "devextreme/ui/dialog";
import { forwardTabbing, backwardTabbing } from "../../_helpers/ui/keyboard";
import gcPopupSupInvFiles from "../../popups/purchasing/gc-popup-sup-inv-files.vue";
import gcPopupInvoiceBalanceHistory from "../../popups/sales/gc-popup-invoice-balance-history.vue";

// import CustomStore from "devextreme/data/custom_store";
import {
  getFxLineTotal,
  getFXTaxLineTotal,
  getFXIncTaxLineTotal,
} from "../../_helpers/formulas/line-totals";
import appConfig from "../../app-config";

function logDev() {
  // eslint-disable-next-line no-console
  console.log("Supplier Invoice >>> ", arguments);
}
var glItemBase = {
  BranchCode: undefined,
  BranchDescription: undefined,
  DivisionCode: undefined,
  DivisionDescription: undefined,
  RequiredByDate: new Date(),
  ETADate: undefined,
  SupplierUM: "Ea",
  SupplierRequired: 0,
  SupplierReceivedQty: 0,
  IsBatchProduct: "No",
  SupplierFXPrice: 0,
  ItemCode: undefined,
  ItemDescription: undefined,
  ItemType: "G",
  LineType: "G",
  LineNo: 0,
  SupplierConversion: 1,
  SupplierPrice: 0,
  IsVariable: "N",
  FXPrice: 0,
  FXAmount: 0,
  TaxCode: "G",
  TaxRate: 10,
  TaxPcnt: 10,
  // GoodsInCode: 0,
  FXLineTotal: 0,
  FXTaxLineTotal: 0,
  TaxableFXLineTotal: 0,
  FXTotal: 0,
  TotalWithTax: 0,
  Comment: undefined,
  FXIncTaxLineTotal: 0,
};

export default {
  mixins: [RouteMixin, FormMixin],
  components: {
    TransactionTemplate,
    gcPopupSupInvFiles,
    gcPopupInvoiceBalanceHistory,
  },
  data() {
    return {
      loaded: false,
      setLoading: false,
      headerEndpoint: undefined,
      newlyLinkedItems: [],
      transactionRecordId: undefined,
      dataModel: {
        CurrencyCode: "",
        SupplierCode: undefined,
        PurchaseOrderCode: undefined,
        DateIn: new Date(),
        DueDate: new Date(),
        InvoiceNo: undefined,
        InvoiceDate: new Date(),
        ExchangeRate: 1,
        NewInvoiceDate: new Date(),

        FXFreight: 0,
        GstAmount: 0,
        FXAmount: 0,
        Balance: 0,
        FXVarianceRounding: 0,
      },
      reload: false,
      validationSummary: [],
      gcPopupVisible: false,
      newDueDate: undefined,
      InvoiceDate: undefined,
      InvoiceMaxDate: undefined,
      AccountingPeriodCode: undefined,
      status: undefined,

      goBackRoute: "/supplier-invoiced",
      serverError: {},
      warningSummary: [],
      InvoiceDateMin: new Date(),
      SupplierData: undefined,
      dataChangedIndex: 0,
      branchDataSourceItems: [],
      divisionDataSourceItems: [],
      taxCodeDataSourceItems: [],

      defaultDataModel: {
        DefaultBranchCode: null,
        DefaultDivisionCode: null,
        DefaultBranchDescription: null,
        DefaultDivisionDescription: null,
        // ETADate: undefined,
      },
      refreshColumns: undefined,
      displayCurrencyCode: undefined,
      DueDateMin: undefined,
      PurchaseOrders: [],
      isMultiplePurchaseOrders: false,
      linkAnItem: undefined,
      productPurchaseListItems: [],
      GLEntryItems: new ArrayStore({
        key: "ID",
        data: [],
      }),
      GLItems: [],
      isInvoiceNoRequired: false,
      GoodsInReceivedListItems: [],
      toolBarFormInstance: undefined,
      defaultTaxCode: undefined,
      VisibleAttachmentPopup: false,
      Attachements: [],

      UpdateDueDateModel: {
        Code: undefined,
        SupplierName: "",
        TermCalculation: "",
        Terms: "",
        InvoiceNo: "",
        InvoiceDate: new Date(),
        DueDate: new Date(),
        NewInvoiceDate: new Date(),
        NewDueDate: new Date(),
      },

      showHistory: false,
      InvoiceCode: undefined,
      customerCode: undefined,
      InvoicedAmount: 0,
    };
  },
  watch: {
    $route(to) {
      if (to.path == "/supplier-invoice/create") {
        this.$store.dispatch("dataContext/setReviewDataSource", []);
        location.reload();
      }
    },
  },
  async created() {
    this.$store.dispatch("dataContext/setReviewDataSource", []);

    if (this.baseView.query)
      if (this.baseView.query.from)
        this.goBackRoute = "/" + this.baseView.query.from;

    await this.$store.dispatch("screenFactors/getFactors", [18, 470, 661]);
    await this.initialized();
  },
  updated() {
    // this.renderHeaderForm();
  },
  async mounted() {},
  beforeDestroy() {
    this.$store.dispatch("dataContext/setSearchText", undefined);
    this.$store.dispatch("dataContext/setReviewDataSource", []);
  },

  computed: {
    ...mapGetters({ reviewDataSource: "dataContext/getReviewDataSource" }),
    ...mapGetters({ dataViewType: "dataContext/getDataViewType" }),
    getDataModel() {
      return this.dataModel;
    },
    gcPopupConfig() {
      return {
        title: "Adjust Due Date",
        callBack: this.gcPopupCallBack,
        gcPopupVisible: this.gcPopupVisible,
        dataModel: this.UpdateDueDateModel,
        formContentReady: this.formContentReady,
        height: 400,
        formOptions: {
          gcLabelLocation: "left",
        },
        items: [
          {
            itemType: "group",
            caption: "",
            colCount: 1,
            items: [
              {
                screenField: "Invoice",
                dataField: "Code",
                label: {
                  text: "Supplier Invoice #",
                },
              },
              {
                dataField: "SupplierName",
                label: {
                  text: "Supplier Name",
                },
              },

              {
                itemType: "group",
                caption: "",
                colCount: 2,
                items: [
                  {
                    dataField: "TermCalculation",
                    label: { text: "Term Method" },
                    id: "term-calculation-selectBox",
                  },
                  {
                    dataField: "Terms",
                    label: { text: "Terms Days" },
                  },
                ],
              },
              {
                screenField: "Invoice",
                dataField: "InvoiceNo",
                label: {
                  text: "Invoice Number",
                },
              },
              {
                screenField: "DateIn",
                dataField: "InvoiceDate",
                label: {
                  text: "Current Invoice Date",
                },
              },
              {
                screenField: "DueDate",
                label: {
                  text: "Current Due Date",
                },
              },
              {
                screenField: "DateIn",
                dataField: "NewInvoiceDate",
                editorType: "dxDateBox",
                label: {
                  text: "New Invoice Date",
                },
                required: true,
                editorOptions: {
                  allowUpdate: true,
                  onValueChanged: (e) => {
                    this.updateDueDateFromModel(e);
                  },
                  onFocusIn: (e) => {
                    if (e.event.target.select) e.event.target.select();
                  },
                },
              },
              {
                screenField: "DueDate",
                dataField: "NewDueDate",
                label: {
                  text: "New Due Date",
                },
                required: true,
                editorOptions: {
                  min: this.InvoiceDate,
                  // max: this.InvoiceMaxDate,
                  allowUpdate: true,
                  onValueChanged: (e) => {
                    if (e.event) {
                      if (new Date(e.value) < new Date(this.InvoiceDate)) {
                        e.component.beginUpdate();
                        e.component.option("value", e.previousValue);
                        e.component.endUpdate();
                      } else this.onChangeNewDueDate(e);
                    }
                  },
                },
              },
            ],
          },
        ],
        save: {
          text: "Update",
          clickCallback: (e) => {
            this.onGcPopUpUpdate(e);
          },
          disabled: !this.newDueDate,
        },
        back: {
          text: "Cancel",
          clickCallback: () => {
            this.gcPopupCallBack();
          },
        },
      };
    },
    getGcPopUpVisible() {
      return this.gcPopupVisible;
    },
    backButtonRoute() {
      return this.goBackRoute;
    },
    getScreenJson() {
      var screenJson = {
        title: "Supplier Invoice",
        endpoint: {
          primary:
            this.baseView.mode !== "create" ? "SupplierInvoice" : undefined,
          postProcess: this.supplierInvoicePostProcess,
        },
        gridData: {
          gridOptions: {
            dataSource: {
              // endpoint:
              //   this.baseView.mode !== "create"
              //     ? "SupplierInvoiceDetail"
              //     : "GoodsInDetail",
              // filter:
              //   this.baseView.mode !== "create"
              //     ? ["SupplierInvoiceCode eq " + this.baseView.id]
              //     : ["PurchaseOrderCode eq " + this.baseView.id],
              serverPaging: true,
              allowGrouping: false,
              // postProcessCallback: this.PostProcess,
            },
            noDataMessage: {
              // this `review` is one of the options in the grid toolbar dropdown that represents 'Review', 'ProductList' 'CustomerList'
              review: {
                addNew: {
                  class: "no-data",
                  title: "No Lines",
                  message: "Get Started, Add a Details Line",
                },
              },

              "product-list": {
                addNew: {
                  class: "no-data",
                  title: "No Product Lines",
                  message: this.dataModel.SupplierCode
                    ? "Products will show if the Supplier is a supplier of the product.  Head over to the Product screen to nominate the suppiler of the product."
                    : "Products will show when a Supplier is selected.",
                },
              },
              "received-list": {
                addNew: {
                  class: "no-data",
                  title: "No outstanding records",
                  message: this.dataModel.SupplierCode
                    ? "There are no outstanding records for the selected supplier."
                    : "Outstanding records will show when a Supplier is selected.",
                },
              },
            },

            // dynamicColumns: true,
            dataGridViews: [
              {
                label: "Review",
                value: "review",
                default: this.baseView.mode == "review",
                dataSource: {
                  items: [],
                },
                columns: this.getReviewColumns,
              },
              {
                label: "Received",
                value: "received-list",
                default: this.baseView.mode == "create",
                dataSource: this.dataModel.SupplierCode
                  ? {
                      serverPaging: false,
                      allowGrouping: false,
                      localDataList: true,
                      local: true,
                      items: this.GoodsInReceivedListPostProcess(
                        this.GoodsInReceivedListItems,
                      ),
                    }
                  : undefined,
                columns: this.getPOColumns,
                // visible: this.baseView.id,
              },
              {
                label: "Product",
                value: "product-list",
                default: false,
                dataSource: {
                  localDataList: true,
                  items: this.ProductPostProcess(this.productPurchaseListItems),
                },
                columns: this.getProductColumns,
                childColumns: [
                  {
                    screenField: "Batch",
                    gridDataField: "BatchNo",
                    allowEditing: false,
                    showEditorAlways: false,
                    cellTemplate: "EditableText",
                  },
                  {
                    screenField: "SupplierBatchNo",
                    cellTemplate: "EditableText",
                  },
                  {
                    screenField: "UseByDate",
                    allowEditing: false,
                    allowSearch: false,
                    allowFiltering: false,
                    cellTemplate: "Date",
                    editable: true,
                  },
                  {
                    screenField: "Quantity",
                    dataField: "SupplierBatchReceivedQty",
                    type: "EditableDecimal",
                    showEditorAlways: true,
                    format: "Decimal-16-2",
                  },
                  {
                    dataField: "ActionDelete",
                    label: "",
                    width: ColumnWidth.ActionColumn.width,
                    minWidth: ColumnWidth.ActionColumn.minWidth,
                    cellTemplate: "ActionDelete",
                  },
                  {
                    dataField: "ActionAddNew",
                    label: "",
                    width: ColumnWidth.ActionColumn.width,
                    minWidth: ColumnWidth.ActionColumn.minWidth,
                    cellTemplate: "ActionAddNew",
                  },
                ],
              },
              {
                label: "GL Entry",
                value: "general-ledger",
                default: false,
                dataSource: {
                  localDataList: true,
                  items: this.GLChartPostProcess(this.GLEntryItems._array),
                },
                columns: this.getGLChartColumns,
              },
            ],
            options: {
              keyboardNavigation: {
                enabled: this.baseView.mode != "review",
                key: "ID",
              },
              focusedRowEnabled: this.baseView.mode != "review",
              onEditorPreparing: this.onEditorPreparing,
              onFocusedCellChanged: this.onFocusedCellChanged,
            },
          },
          toolbar: {
            search: true,
            columnChooser: false,
            export: false,
            openFilter: false,
            expand: true,
            review: true,
            customButtons: [
              {
                icon: "plus",
                label: "Link an Item",
                // visible: FeatureStorage.checkPermission(
                //   "DespatchOrderDetailAddItem",
                //   "edit"
                // ),
                visible: this.dataViewType == "product-list",
                clickAction: () => {
                  this.enableLinkAnItem();
                },
                buttonLocation: "left",
              },
            ],
          },
          columns: [],
          valueChangedEventListners: [
            {
              dataField: "SupplierReceivedQty",
              listner: (e, lineData) => {
                if (this.dataViewType == "received-list") {
                  if (e.value > lineData.data.ReceivedQty)
                    lineData.data.SupplierReceivedQty =
                      lineData.data.ReceivedQty;
                  else lineData.data.SupplierReceivedQty = e.value;
                } else lineData.data.SupplierReceivedQty = e.value;

                if (lineData.data.SupplierPrice)
                  lineData.data.FXPrice = lineData.data.SupplierPrice;

                lineData.data.SupplierUMQuantity =
                  lineData.data.SupplierReceivedQty;

                lineData.data.FXAmount = getFxLineTotal(
                  lineData.data.FXPrice,
                  lineData.data.SupplierReceivedQty,
                );
                lineData.data.FXTaxLineTotal = getFXTaxLineTotal(
                  lineData.data.FXAmount,
                  lineData.data.TaxPcnt,
                );
                lineData.data.FXIncTaxLineTotal = getFXIncTaxLineTotal(
                  lineData.data.FXAmount,
                  lineData.data.FXTaxLineTotal,
                );

                logDev("Calling valueChangedEventListners", lineData.data);

                this.mergeWithReviewView(
                  lineData.data.FXAmount == 0 ? false : true,
                  lineData.data,
                );

                this.CalculateHeaderTotal();
                this.CalculateGstAmount();
              },
            },
            {
              dataField: "FXPrice",
              listner: (e, lineData) => {
                lineData.data = this.isPriceUpdated(lineData.data, e.value);
                lineData.data.FXPrice = e.value;
                lineData.data.Price = e.value;

                lineData.data.FXAmount = getFxLineTotal(
                  lineData.data.FXPrice,
                  lineData.data.SupplierReceivedQty,
                );
                lineData.data.FXTaxLineTotal = getFXTaxLineTotal(
                  lineData.data.FXAmount,
                  lineData.data.TaxPcnt,
                );
                lineData.data.FXIncTaxLineTotal = getFXIncTaxLineTotal(
                  lineData.data.FXAmount,
                  lineData.data.FXTaxLineTotal,
                );

                if (lineData.data.ItemCode) {
                  // this.renderHeaderForm();

                  let mergeFlag =
                    lineData.data.FXAmount == 0 || lineData.data.Price == 0
                      ? false
                      : true;

                  this.mergeWithReviewView(mergeFlag, lineData.data);
                }

                this.CalculateGstAmount();
                this.CalculateHeaderTotal();
              },
            },
            {
              dataField: "FXAmount",
              listner: (e, lineData) => {
                lineData.data.FXAmount = e.value;
                lineData.data = this.isPriceUpdated(
                  lineData.data,
                  lineData.data.FXAmount / lineData.data.SupplierReceivedQty,
                );
                lineData.data.FXPrice = (
                  lineData.data.FXAmount / lineData.data.SupplierReceivedQty
                ).roundNumber(4);
                lineData.data.Price = lineData.data.FXPrice;

                // lineData.data.FXAmount = getFxLineTotal(lineData.data.FXPrice, lineData.data.SupplierReceivedQty);
                lineData.data.FXTaxLineTotal = getFXTaxLineTotal(
                  lineData.data.FXAmount,
                  lineData.data.TaxPcnt,
                );
                lineData.data.FXIncTaxLineTotal = getFXIncTaxLineTotal(
                  lineData.data.FXAmount,
                  lineData.data.FXTaxLineTotal,
                );

                if (lineData.data.ItemCode) {
                  // this.renderHeaderForm();

                  let mergeFlag =
                    lineData.data.FXAmount == 0 || lineData.data.Price == 0
                      ? false
                      : true;

                  this.mergeWithReviewView(mergeFlag, lineData.data);
                }
                this.CalculateGstAmount();
                this.CalculateHeaderTotal();
              },
            },
            {
              dataField: "SupplierBatchReturnedQty",
              listner: (e, lineData, items, grid, lineParent) => {
                this.onSupplierBatchReturnedQtyChange(
                  e,
                  lineData,
                  items,
                  grid,
                  lineParent,
                );
              },
            },

            {
              dataField: "Comment",
              listner: (e, lineData) => {
                if (e.value.length >= 1000) {
                  this.addToValidationSum(
                    "comments only allow maximum length of 1000 characters",
                  );
                  lineData.data.Comment = e.previousValue;
                  e.component.beginUpdate();
                  e.component.option("value", e.previousValue);
                  e.component.endUpdate();
                } else lineData.data.Comment = e.value;

                var index = this.findReviewDataSourceIndex(lineData.data);

                if (e.value) {
                  if (index != -1) {
                    this.removeFromReview(index);
                  }
                  this.addToReview(lineData.data);
                } else {
                  if (lineData.data.FXAmount == 0) {
                    if (index != -1) {
                      this.removeFromReview(index);
                    }
                  }
                }
                // this.footerValueCalculations(lineData);
              },
            },
            {
              dataField: "TaxCode",
              listner: (e, lineData) => {
                lineData.data.TaxCode = e.itemData.Code;
                this.SubtractFromGstAmount(
                  this.calculateRowTaxWithTax(lineData.data),
                );
                this.subtractFromHeaderTotal(
                  lineData.data.FXAmount +
                    this.calculateRowTaxWithTax(lineData.data),
                );
                lineData.data.TaxPcnt = e.itemData.Rate;
                lineData.data.TaxRate = e.itemData.Rate;
                this.AddToGstAmount(this.calculateRowTaxWithTax(lineData.data));
                this.addToHeaderTotal(
                  lineData.data.FXAmount +
                    this.calculateRowTaxWithTax(lineData.data),
                );
                this.mergeWithReviewView(
                  lineData.data.FXAmount == 0 ? false : true,
                  lineData.data,
                );
              },
            },
            // Child Grid Action Listners
            {
              dataField: "BatchNo",
              listner: (e, lineData) => {
                lineData.data.BatchNo = e.value;
              },
            },
            {
              dataField: "SupplierBatchNo",
              listner: (e, lineData) => {
                lineData.data.SupplierBatchNo = e.value;
              },
            },
            {
              dataField: "UseByDate",
              listner: (e, lineData) => {
                lineData.data.UseByDate = e.value;
              },
            },
            {
              dataField: "BranchCode",
              listner: (e, lineData) => {
                lineData.data.BranchCode = e.itemData.Code;
              },
            },
            {
              dataField: "DivisionCode",
              listner: (e, lineData) => {
                lineData.data.DivisionCode = e.itemData.Code;
              },
            },
            {
              dataField: "SupplierBatchReceivedQty",
              listner: (e, lineData, items, grid, lineParent) => {
                lineData.data.SupplierBatchReceivedQty = e.value;
                lineData.data.ReceivedQty =
                  lineData.data.ActualStockConversion *
                  lineData.data.SupplierBatchReceivedQty;

                let totalBatchPickedQty = 0;
                lineParent.data.ChildDataSource.forEach((x) => {
                  totalBatchPickedQty += x.SupplierBatchReceivedQty;
                });

                lineParent.data.SupplierReceivedQty = totalBatchPickedQty;

                lineParent.data.SupplierUMQuantity = totalBatchPickedQty;

                if (lineParent.data.SupplierPrice) {
                  lineData.data = this.isPriceUpdated(
                    lineData.data,
                    lineParent.data.SupplierPrice,
                  );
                  lineParent.data.FXPrice = lineParent.data.SupplierPrice;
                }

                lineParent.data.FXAmount = parseFloat(
                  lineParent.data.FXPrice * lineParent.data.SupplierReceivedQty,
                ).roundNumber(2);

                var index = this.findReviewDataSourceIndex(lineParent.data); // -1;

                if (e.value) {
                  if (index != -1) {
                    this.removeFromReview(index);
                  }
                  this.addToReview(lineParent.data);
                } else {
                  if (lineParent.data.FXAmount == 0) {
                    if (index != -1) {
                      this.removeFromReview(index);
                    }
                  }
                }
              },
            },

            {
              dataField: "ActionDelete",
              listner: (e, lineData, lineParent) => {
                this.onActionDetele(e, lineData, lineParent);
              },
            },
            {
              dataField: "ActionAddNew",
              listner: (e, lineData, lineParent) => {
                if (e && lineData)
                  lineParent.data.ChildDataSource.push({
                    BatchNo: "",
                    SupplierBatchNo: "",
                    SupplierCode: "",
                    UseByDate: null,
                    SupplierBatchReceivedQty: 0,
                    ActualStockConversion: lineParent.data.SupplierConversion,
                    ReceivedQty: lineParent.data.SupplierReceivedQty,
                  });
              },
            },
            // New Fields
            {
              dataField: "FXIncTaxLineTotal",
              listner: (e, lineData) => {
                var taxPcnt = 0;
                if (lineData.data.TaxPcnt) taxPcnt = lineData.data.TaxPcnt;

                lineData.data.FXIncTaxLineTotal = e.value;
                lineData.data.FXAmount = (
                  lineData.data.FXIncTaxLineTotal /
                  (1 + taxPcnt / 100)
                ).roundNumber(2);
                lineData.data.FXTaxLineTotal = (
                  lineData.data.FXAmount *
                  (taxPcnt / 100)
                ).roundNumber(2);
                lineData.data = this.isPriceUpdated(
                  lineData.data,
                  lineData.data.FXAmount / lineData.data.SupplierReceivedQty,
                );
                lineData.data.FXPrice = (
                  lineData.data.FXIncTaxLineTotal /
                  (1 + taxPcnt / 100) /
                  lineData.data.SupplierReceivedQty
                ).roundNumber(4);

                this.mergeWithReviewView(
                  lineData.data.FXAmount == 0 ? false : true,
                  lineData.data,
                );

                this.CalculateGstAmount();
              },
            },
          ],
        },
        footerData: {
          footerItems: [
            {
              screenField: "SalesUMItemCount",
              dataField: "SupplierRequired",
              location: "left",
              label: "Line Count",
              value: 0,
              // eslint-disable-next-line no-unused-vars
              customCalc: (headerData, gridItems) => {
                var count = 0;
                this.reviewDataSource.forEach((element) => {
                  if (element) count++;
                });

                return count;
              },
            },
            {
              dataField: "FXAmount",
              screenField: "FXTotal",
              location: "right",
              value: 0,
              label: "Sub Total (" + this.getCurrencyCode + ")",
              format: "Decimal-16-2C",
            },
            {
              screenField: "FXTotal",
              dataField: "FXFreight",
              location: "right",
              label: "Freight (" + this.getCurrencyCode + ")",
              value: 0,
              format: "Decimal-16-2C",
              customCalc: (headerData) => {
                return headerData.FXFreight;
              },
              visible: false,
            },
            {
              screenField: "GstAmount",
              dataField: "FXTaxLineTotal",
              location: "right",
              value: 0,
              format: "Decimal-16-2C",
              label: "Tax (" + this.getCurrencyCode + ")",
              // customCalc: (headerData) => {
              //   return headerData.GstAmount;
              // },
            },
            {
              screenField: "FXTotal",
              dataField:
                this.baseView.mode == "create" ? "FXTotal" : "FXAmount",
              location: "right",
              value: 0,
              format: "Decimal-16-2C",
              label: "Total (" + this.getCurrencyCode + ")",
              customCalc:
                this.baseView.mode == "create"
                  ? (headerData, gridItems) => {
                      var total = 0;
                      gridItems.forEach((element) => {
                        if (this.gridDataField == "received-list") {
                          if (element.CheckInclude) {
                            total += (
                              element.FXAmount + element.FXTaxLineTotal
                            ).roundNumber(2);
                          }
                        } else {
                          total += (
                            element.FXAmount + element.FXTaxLineTotal
                          ).roundNumber(2);
                        }
                      });
                      return total;
                    }
                  : (headerData) => {
                      return (
                        headerData.FXAmount - headerData.Rounding
                      ).roundNumber(2);
                    },
            },
            {
              screenField: "Rounding",
              dataField: "FXVarianceRounding",
              location: "right",
              label: "Tax Adjustment (" + this.getCurrencyCode + ")",
              customCalc: (headerData) => {
                return headerData.FXVarianceRounding;
              },
            },
            {
              dataField: "Balance",
              screenField: "Balance",
              location: "right",
              // value: 0,
              label: "Balance (" + this.getCurrencyCode + ")",
              customCalc:
                this.baseView.mode == "create"
                  ? (headerData, gridItems) => {
                      var total = 0;
                      gridItems.forEach((element) => {
                        if (this.gridDataField == "received-list") {
                          if (element.CheckInclude)
                            total += (
                              element.FXAmount + element.FXTaxLineTotal
                            ).roundNumber(2);
                        } else {
                          total += (
                            element.FXAmount + element.FXTaxLineTotal
                          ).roundNumber(2);
                        }
                      });
                      return (
                        headerData.FXAmount -
                        (total + headerData.FXVarianceRounding)
                      ).roundNumber(2);
                    }
                  : () => {
                      return 0;
                    },
              // format: "Decimal-16-4C",
            },
          ],
        },
      };
      return screenJson;
    },
    getHeaderScreenJson() {
      return {
        headerData: {
          headerToolbar: {
            screenName:
              this.baseView.mode == "review"
                ? "Supplier Invoice Review"
                : "Purchase Orders - Invoiced",
            pdf: this.baseView.mode == "review",
            audit: this.baseView.mode == "review",
            status: this.baseView.mode == "review",
            email: this.baseView.mode == "review",
            notes: false,
            save: this.baseView.mode != "review",
            saveCallback: this.saveSupplierInvoice,
            history: true,
            historyCallBack: this.historyCallBack,
            toolTipText: "View Invoice Balance History",
            attachment: true,
            showAttachment: () => {
              this.showAttachmentModel();
            },
            formContentReady: (e) => {
              if (e && this.baseView.mode != "review" && this.loaded)
                this.onHeaderFormContentReady(e);
            },
            toolbarFormItems: [
              {
                screenField:
                  this.baseView.id && this.baseView.mode == "create"
                    ? undefined
                    : "Supplier",
                dataField:
                  this.baseView.id && this.baseView.mode == "create"
                    ? "SupplierName"
                    : "SupplierCode",
                cssClass: "toolbar-supplier-label",
                visible: this.baseView.mode != "review",
                dataSourceConfig: {
                  endpoint: "api/Supplier",
                  select: [
                    "Inactive",
                    "DefaultBranchCode",
                    "WetApplicable",
                    "TermCalculation",
                    "Terms",
                    "Name",
                    "Code",
                    "CurrencyCode",
                    "IsTaxableSupplier",
                  ],
                  sort: {
                    selector: "Name",
                    asc: true,
                  },
                  filter: [["Inactive", "=", "N"]],
                },
                editorOptions: {
                  tabIndex:
                    this.baseView.id || this.baseView.query.SUP_ID ? -1 : 1,
                  dropDownOptions: {
                    minWidth: 300,
                  },
                  width: 300,
                  placeholder: "Supplier Name",
                  // onValueChanged: this.onCustomerCodeValueChanged.bind(this),
                  showClearButton: true,
                  onValueChanged: ({ value, previousValue }) => {
                    if (value != null) {
                      this.onSupplierClick(value);
                      this.getPurchaseOrdersBySupplierCode(value);
                      this.getProductPurchaseList(value, true);
                      this.GLEntryItems.clear();
                      this.GLEntryItems.insert(this.getNewRowDataForGLEntry());

                      if (previousValue) {
                        this.$store.dispatch(
                          "dataContext/setReviewDataSource",
                          [],
                        );

                        var dataGridInstance =
                          this.$refs["supplier-invoice"].$refs[
                            "transactionGrid"
                          ].$refs["gc-dat-gridtransaction-grid"].instance;

                        // remove previously focused rowkey.
                        // If this was not done there will be another call going out to select the selectedRow inline witht the previous selection
                        dataGridInstance.option("focusedRowKey", null);

                        this.CalculateGstAmount();
                        this.CalculateHeaderTotal();
                      }

                      this.clearInvoiceNo();
                      this.getGoodsInReceivedList();
                    }
                  },
                  onSelectionChanged: (e) => {
                    if (e.selectedItem) {
                      this.onSupplierSelectionChanged(e);
                    }
                  },
                  readOnly: this.baseView.id || this.baseView.query.SUP_ID,
                },
                label: {
                  text: "Supplier",
                  visible: false,
                },
                required: true,
              },
            ],
            toolbarFormLocation: "after",
            emailMenuItems: {
              referenceNoField: "Invoice",
              makeDisabled: (dataModel, emailRecords) => {
                var items = [];

                emailRecords.forEach((element) => {
                  items.push({
                    ReportDisplayName: element.ReportDisplayName,
                    ScreenName: element.ScreenName,
                    ScreenLayoutApplicationFeatureCode:
                      element.ScreenLayoutApplicationFeatureCode,
                    TransactionCode: element.TransactionCode,
                    disabled: element.disabled,
                  });
                });

                return items;
              },
            },

            auditItems: [
              {
                itemType: "group",
                caption: "",
                items: [
                  {
                    dataField: "FormattedDateChanged",
                    label: { text: "Created By", location: "left" },
                    editorType: "dxTextBox",
                    editorOptions: {
                      // // disabled: true,
                    },
                  },
                  {
                    dataField: "FormattedDateChanged",
                    label: { text: "Changed By", location: "left" },
                    editorType: "dxTextBox",
                    editorOptions: {
                      // disabled: true,
                    },
                  },
                ],
              },
            ],

            ellipsis:
              this.baseView.mode == "review"
                ? {
                    menuItems: [
                      {
                        menuText: "Adjust Due Date",
                        disabled: !FeatureStorage.checkPermission(
                          "CashPayment",
                          "create",
                        ),
                      },
                      {
                        menuText: "Pay",
                        disabled: !FeatureStorage.checkPermission(
                          "CashPayment",
                          "create",
                        ),
                      },
                      {
                        menuText: "Credit",
                        disabled:
                          !FeatureStorage.checkPermission(
                            "SupplierInvoice",
                            "create",
                          ) ||
                          this.dataModel.PurchaseOrderLinked == "N" ||
                          this.status === "Credited" ||
                          this.status === "Credit",
                      },
                    ],
                    visible: true,
                    disabled: this.status === "Paid",
                    clickAction: (e) => {
                      if (e.itemData.menuText === "Credit") {
                        this.goToSupplierCredit();
                      } else if (e.itemData.menuText === "Adjust Due Date") {
                        this.visibleGcPopUp();
                      } else {
                        this.goToPay(this.baseView.id);
                      }
                    },
                  }
                : undefined,
          },
          formItems: [
            {
              itemType: "group",
              caption: "",
              colCount: 3,
              items: [
                {
                  itemType: "group",
                  caption: "",
                  items: [
                    {
                      screenField: "PurchaseOrder",
                      dataField: "PurchaseOrderCode",
                      label: {
                        text: "Purchase Order",
                      },
                      cellTemplate: "Record",
                      allowUpdate: true,
                      editorOptions: {
                        tabIndex: 2,
                        onItemClick: () => {
                          this.onPurchaseOrderValueChanged();
                        },
                        showClearButton: true,
                        onValueChanged: () => {
                          this.getGoodsInReceivedList();
                        },
                      },
                      itemTemplate: (data) => {
                        return ` <div class="custom-auto-complete" id="${
                          data.PurchaseOrderCode
                        }" >
                              <span class="auto-complete-primary">
                                ${data.PurchaseOrderCode}
                              </span>
                              <span class="record-secondary gc-grid-code">
                                ${new Date(
                                  data.PurchaseOrderDate,
                                ).toShortDateString()}
                              </span>
                            </div>`;
                      },
                      visible: this.isCreateMode() && !this.baseView.id,
                      dataSourceConfig: {
                        data: this.dataModel.SupplierCode
                          ? this.PurchaseOrders
                          : [],
                      },
                      searchExpr: ["PurchaseOrderCode", "PurchaseOrderDate"],
                    },
                    {
                      screenField: "Invoice",
                      dataField: "PurchaseOrderCode",
                      label: {
                        text: "Purchase Order",
                      },
                      editorOptions: {
                        tabIndex: -1,
                        readOnly: true,
                      },
                      visible: this.isReviewMode() || this.baseView.id,
                    },
                    {
                      screenField: "DateIn",
                      editorOptions: {
                        min: this.InvoiceDate,
                        max: this.InvoiceMaxDate,
                        tabIndex: 3,
                      },
                      required: true,
                    },

                    {
                      screenField: "PayeeName",
                      visible: this.baseView.mode == "create",
                      editorOptions: {
                        tabIndex: 4,
                        maxLength: 100,
                      },
                    },

                    // {
                    //   screenField: "FXFreight",
                    //   label: {
                    //     text: "Freight (" + this.getCurrencyCode + ")",
                    //   },
                    //   visible: false,
                    //   editorOptions: {
                    //     tabIndex: 5,
                    //     onValueChanged: () => {
                    //       this.onChangeFXFreight();
                    //     },
                    //   },
                    // },
                    // {
                    //   screenField: "GstAmount",
                    //   dataField: "GstAmount",
                    //   label: {
                    //     text: "Tax (" + this.getCurrencyCode + ")",
                    //   },
                    //   editorOptions: {
                    //     tabIndex: 6,
                    //     onValueChanged: () => {
                    //       this.onChangeGstAmount();
                    //     },
                    //   },
                    // },
                  ],
                },
                {
                  itemType: "group",
                  caption: "",
                  items: [
                    {
                      screenField: "Invoice",
                      dataField: "InvoiceNo",
                      label: {
                        text: "Invoice Number",
                      },
                      editorOptions: {
                        tabIndex: 5,
                        onValueChanged: (e) => {
                          if (e.event) {
                            this.focusHeaderFormItem("InvoiceDate");
                            this.InvoiceNoExistsRuleCallback(e);
                          }
                        },
                        maxLength: 20,
                      },
                      value: this.dataModel.InvoiceNo,
                      required: this.isInvoiceNoRequired,
                    },
                    {
                      screenField: "InvoiceDate",
                      label: {
                        text: "Invoice Date",
                      },
                      editorOptions: {
                        tabIndex: 6,
                        // min: this.InvoiceDateMin,
                        onValueChanged: (e) => {
                          if (e.value) {
                            this.updateDueDate(e);
                          }
                        },
                        onKeyDown: (e) => {
                          if (forwardTabbing(e)) {
                            setTimeout(() => {
                              this.focusHeaderFormItem("DueDate");
                            }, 100);
                            // });
                          } else if (backwardTabbing(e)) {
                            setTimeout(() => {
                              this.focusHeaderFormItem("InvoiceNo");
                            }, 100);
                          }
                        },
                      },
                      required: true,
                    },
                    {
                      screenField: "DueDate",
                      required: true,
                      editorOptions: {
                        tabIndex: 7,
                        min: this.DueDateMin,
                      },
                    },
                  ],
                },
                {
                  itemType: "group",
                  caption: "",
                  colCount: 1,
                  items: [
                    {
                      itemType: "group",
                      caption: "",
                      colCount: 2,
                      items: [
                        {
                          screenField: "CurrencyCode",
                          editorOptions: {
                            allowUpdate: false,
                          },
                        },
                        {
                          screenField: "ExchangeRate",
                          allowUpdate: this.dataModel.CurrencyCode != "AUD",
                          validationRules: [
                            {
                              type: "custom",
                              validationCallback: ({ value, rule }) => {
                                rule.message = `Exchange rate Cannot be 0 or Negative`;
                                return value > 0;
                              },
                            },
                          ],
                          editorOptions: {
                            tabIndex:
                              this.dataModel.CurrencyCode != "AUD" ? 8 : -1,
                          },
                        },
                      ],
                    },
                    {
                      screenField: "FXAmount",
                      dataField: "FXAmount",
                      format: "Decimal-16-2",
                      label: {
                        text: "Total (" + this.getCurrencyCode + ")",
                      },
                      editorType: "dxNumberBox",
                      editorOptions: {
                        tabIndex: 9,
                        onValueChanged: (e) => {
                          this.onChangeGstAmount();
                          this.onChangeFXAmount(e);
                        },
                      },
                    },
                    {
                      screenField: "Rounding",
                      dataField: "FXVarianceRounding",
                      editorOptions: {
                        tabIndex: 10,
                        onValueChanged: () => {
                          this.onChangeFXFreight();
                        },
                        onKeyDown: (e) => {
                          this.moveOnKeyDown(e);
                        },
                      },

                      label: {
                        text: "Tax Adjustment (" + this.getCurrencyCode + ")",
                      },
                    },
                  ],
                },
              ],
            },
          ],
          title: {
            // Credit # [CreditNote] for Invoice # [InvoiceNumber]
            createModeIsEditMode: true,
            primary: {
              primary: {
                dataField: this.baseView.mode == "create" ? undefined : "Code",
                text:
                  this.baseView.mode == "create"
                    ? "Create Supplier Invoice"
                    : "Supplier Invoice # ",
              },
              secondary: {
                dataField: undefined,
                text: undefined,
              },
            },
            secondary: {
              dataField:
                this.baseView.mode == "review" ? "SupplierName" : undefined,
              text: undefined,
            },
          },
          formContentReady: (e) => {
            if (e && this.baseView.mode != "review" && this.loaded)
              this.onFormContentReady(e);
          },
        },
      };
    },
    getFXFreight() {
      return this.dataModel.FXFreight;
    },
    getPOColumns() {
      return [
        {
          screenField: "CheckInclude",
          allowEditing: false,
          defaultValue: false,
          valueChangeCallBack: this.checkBoxValueChange,
          allowHiding: false,
          showInColumnChooser: false,
          fixed: true,
          fixedPosition: "left",
          label: "",
          width: 50,
          minWidth: 50,
          visible: this.baseView.mode == "create",
        },
        {
          screenField: "PurchaseOrder",
          dataField: "PurchaseOrderCode",
          width: ColumnWidth.PurchaseOrderWrap.width,
          minWidth: ColumnWidth.PurchaseOrderWrap.minWidth,
          sortOrder: "asc",
          sortIndex: 0,
          visible: true,
          allowSearch: false,
          hyperlink: {
            url: `purchase-order/review/__ID__`,
            dataField: "PurchaseOrderCode",
            target: "_blank",
          },
        },
        {
          screenField: "GoodsIn",
          dataField: "GoodsInCode",
          // width: "auto",
          width: ColumnWidth.GoodsInCode.width,
          minWidth: ColumnWidth.GoodsInCode.minWidth,
          hyperlink: {
            url: `goods-in-review/review/__ID__`,
            dataField: "GoodsInCode",
            target: "_blank",
          },
        },
        {
          dataField: "PurchaseOrderComputedCode",
          allowSearch: true,
          visible: false,
        },
        {
          dataField: "GoodsInComputedCode",
          allowSearch: true,
          visible: false,
        },
        {
          screenField: "Item",
          label: "Product/Account",
          dataField: "ItemCode",
          gridDataField: "ItemCode",
          // width: ColumnWidth.ProductDescription.width,
          minWidth: ColumnWidth.ProductDescription.minWidth,
          // sortOrder: "asc",
          // sortIndex: 0,
          cellTemplateRecord: {
            image: {
              codeDataField: "ItemCode",
              descriptionDataField: "ItemDescription",
              hasPrimaryImageDataField: "HasPrimaryImage",
            },
            primary: [
              {
                dataField: "ItemDescription",
              },
            ],
            secondary: [
              {
                dataField: "ItemCode",
              },
            ],
          },
          exportFields: [
            {
              dataField: "ItemCode",
              label: "Customer Code",
            },
            {
              dataField: "ItemDescription",
              label: "Customer Name",
            },
          ],
          // fixed: true,
          // fixedPosition: "left",
          allowHiding: false,
        },

        // {
        //   screenField: "ItemType",
        //   dataField: this.baseView.mode == "create" ? "LineType" : "ItemType",
        //   label: "Type",
        //   width: 75,
        // },
        {
          screenField: "SalesUM",
          dataField: "SupplierUM",
          width: ColumnWidth.UnitOfMeasure.width,
        },
        {
          screenField: "TaxCode",
          label: "Tax",
          cellTemplateRecord: undefined,
          exportFields: undefined,
          cellTemplate: undefined,
          width: ColumnWidth.TaxCode.width,
        },

        // {
        //   screenField: "PurchaseOrder", // TODO : NEW FIELD
        // },
        {
          screenField: "ReceivedQty",
          dataField:
            this.baseView.mode == "create" ? "ReceivedQty" : "Received",
          width: ColumnWidth.Quantity4DecimalPoints.width,
          minWidth: ColumnWidth.Quantity4DecimalPoints.minWidth,
          format: "Decimal-16-4",
          allowEditing: false,
        },
        {
          screenField: "Quantity",
          dataField:
            this.baseView.mode == "create"
              ? "SupplierReceivedQty"
              : "SupplierUMQuantity",
          label: "Invoiced",
          width: ColumnWidth.Quantity4DecimalPoints.width,
          minWidth: ColumnWidth.Quantity4DecimalPoints.minWidth,
          type: "EditableDecimal",
          allowEditing: false,
          // makeDisabled: (data) => {
          //   if (data.data.CheckInclude) {
          //     return false;
          //   } else return true;
          // },
          // onKeyDown: this.onReverseTab,
          // showEditorAlways: this.baseView.mode == "create",
        },
        {
          screenField: "FXPrice",
          label: "Unit Price (" + this.getCurrencyCode + ")",
          minWidth: ColumnWidth.Price4DecimalPoints.minWidth,
          width: ColumnWidth.Price4DecimalPoints.width,
          type: "EditableDecimal",
          allowEditing: true,
          showEditorAlways: this.baseView.mode == "create",
          makeDisabled: (data) => {
            if (data.data.CheckInclude) {
              return false;
            } else return true;
          },
          onKeyDown: (e, lineData) => {
            let nextField = "FXAmount";
            if (forwardTabbing(e)) {
              if (lineData.data.SupplierReceivedQty == 0) {
                e.event.preventDefault();
                nextField = "Comment";
              }
              setTimeout(() => {
                this.focusOnEditableCell(lineData.rowIndex, nextField);
              }, 100);
            } else if (backwardTabbing(e)) {
              this.onReverseTab(e, lineData);
            } else this.onEnterItemCode(e, lineData, nextField);
          },
          format: "Decimal-16-4",
        },

        {
          screenField: "FXTotal",
          dataField: "FXAmount",
          allowEditing: true,
          label: "Ex Total (" + this.getCurrencyCode + ")",
          minWidth: ColumnWidth.Price4DecimalPoints.minWidth,
          width: ColumnWidth.Price4DecimalPoints.width,
          type: "EditableDecimal",
          showEditorAlways: this.baseView.mode == "create",
          makeDisabled: (data) => {
            if (data.data.CheckInclude && data.data.SupplierReceivedQty != 0) {
              return false;
            } else return true;
          },
          allowFiltering: false,
          allowSearch: false,
          allowSorting: false,
        },
        {
          screenField: "TaxTotal",
          dataField: "FXTaxLineTotal",
          label: "Tax (" + this.getCurrencyCode + ")",
          minWidth: ColumnWidth.TaxFXLineTotal.minWidth,
          width: ColumnWidth.TaxFXLineTotal.width,
          cellTemplate: false,
        },
        {
          screenField: "IncTaxFXTotal",
          dataField: "FXIncTaxLineTotal",
          label: "Inc Total (" + this.getCurrencyCode + ")",
          minWidth: ColumnWidth.Price4DecimalPoints.minWidth,
          width: ColumnWidth.Price4DecimalPoints.width,
          allowEditing: true,
          type: "EditableDecimal",
          showEditorAlways: this.baseView.mode == "create",
          makeDisabled: (data) => {
            if (data.data.CheckInclude && data.data.SupplierReceivedQty != 0) {
              return false;
            } else return true;
          },
          allowFiltering: false,
          allowSearch: false,
          allowSorting: false,
        },
        {
          screenField: "Comments",
          dataField: "Comment",
          // allowEditing: this.baseView.mode != "review",
          showEditorAlways: this.baseView.mode == "create",
          allowEditing: true,
          allowSearch: false,
          allowSorting: false,
          minWidth: ColumnWidth.Comment.minWidth,
          width: ColumnWidth.Comment.width,
          editCellTemplate: "EditableTextArea",
          // onKeyDown: this.onToNextLine,
          makeDisabled: (data) => {
            if (data.data.CheckInclude) {
              return false;
            } else return true;
          },
          onKeyDown: (e, lineData) => {
            if (backwardTabbing(e)) {
              if (lineData.data.SupplierReceivedQty == 0) {
                e.event.preventDefault();
                setTimeout(() => {
                  this.focusOnEditableCell(lineData.rowIndex, "FXPrice");
                }, 100);
              }
            } else this.onToNextLine(e, lineData);
          },
          editorOptions: {
            maxLength: 100,
          },
        },
      ];
    },
    getProductColumns() {
      var columns = [
        {
          screenField: "Product",
          sortOrder: "asc",
          gridDataField: "ProductCode",
          sortIndex: 0,
          fixed: true,
          fixedPosition: "left",
          minWidth: ColumnWidth.ProductOrAccount.width,
        },
      ];
      // return columns;
      return columns
        .concat(this.getBranchDivisionColumns)
        .concat([
          {
            screenField: "SalesUM",
            dataField: "SupplierUM",
            allowSearch: false,
            allowSorting: this.dataViewType == "review",
            allowFiltering: false,
            width: ColumnWidth.UnitOfMeasure.width,
            minWidth: ColumnWidth.UnitOfMeasure.minWidth,
          },
          {
            screenField: "TaxCode",
            label: "Tax",
            cellTemplateRecord: undefined,
            exportFields: undefined,
            cellTemplate: undefined,
            width: ColumnWidth.TaxCode.width,
            // visible: this.dataViewType == "product-list",
          },
        ])
        .concat(this.getCommonColumns)
        .concat([
          {
            caption: "",
            dataField: "",
            type: "buttons",
            tabIndex: -1,
            buttons: [
              {
                name: "copy",
                icon: "copy",
                onClick: (e) => {
                  this.productListCopyLine(e, "copy-line");
                },
              },
              {
                name: "remove",
                icon: "trash",
                onClick: (e) => {
                  this.productListDeleteLine(e, "remove-line");
                },
                visible: (e) => {
                  if (e.row.data.IsCopy) return true;
                  else return false;
                },
              },
            ],
            visible: this.baseView.mode != "review",
            width: 60,
          },
        ]);
    },

    getGLChartColumns() {
      var columns = [
        {
          // screenField: "Item",
          label: "Account",
          dataField: "ComputedStringCode",
          // sortOrder: "asc",
          // sortIndex: 0,
          fixed: true,
          fixedPosition: "left",
          exportFields: [
            // {
            //   dataField:
            //     this.dataViewType == "review" ? "Code" : "ComputedStringCode",
            //   label: "Item Code",
            // },
            {
              dataField: "Description",
              label: "Item Description",
            },
          ],
          // minWidth: ColumnWidth.AccountCode.minWidth,
          width: 100,
          cssClass: "edit-cell-textbox-field account-editable-field",
          allowEditing: true,
          editorType: "dxSelectBox",
          // lookup: {
          //   allowClearing: false,
          //   dataSource: () => {
          //     return new CustomStore({
          //       loadMode: "raw",
          //       load: () => {
          //         return PurchaseOrder.getCustomData({
          //           url: "GLChart",
          //           filter: "Inactive eq 'N'",
          //           sort: "ComputedStringCode asc",
          //         })
          //           .then((res) => {
          //             return res.data.value;
          //           })
          //           .catch((err) => {
          //             if (err) return [];
          //           });
          //       },
          //     });
          //   },
          //   displayExpr: "ComputedStringCode",
          //   valueExpr: "ComputedStringCode",
          //   searchExpr: ["ComputedStringCode", "Description"],
          // },
          editorOptions: {
            dataSource: PurchaseOrder.dataSourceConfig("api/GLChart", {
              filter: [["Inactive", "=", "N"]],
              sort: [{ selector: "ComputedStringCode", asc: true }],
            }),
            displayExpr: "ComputedStringCode",
            valueExpr: "ComputedStringCode",
            valueChangeEvent: "keydown keyup",
            searchTimeout: 10,
            searchMode: "contains",
            searchEnabled: true,
            searchExpr: ["ComputedStringCode", "Description"],
            itemTemplate: (data) => {
              return ` <div class="custom-auto-complete">
                        <span class="auto-complete-primary">
                          ${data.ComputedStringCode}
                        </span>
                        <span class="record-secondary gc-grid-code">
                          ${data.Description}
                        </span>
                      </div>`;
            },

            onSelectionChanged: (e) => {
              this.addSelectedGLItems(e);
            },
            onKeyDown: (e, lineData) => {
              this.onEnterItemCode(e, lineData, "TaxCode");
              this.onReverseTab(e, lineData);
            },
            onItemClick: (e, lineData) => {
              this.onEnterItemCode(
                { event: { key: "Enter" } },
                lineData,
                "TaxCode",
              );
            },
            dropDownOptions: {
              width: 400,
            },
          },
          setCellValue: (newData, value, currentRowData) => {
            newData.ComputedStringCode = value;
            newData.ItemCode = value.toString();
            newData.SupplierReceivedQty = 1;

            if (currentRowData.FXPrice != 0) {
              if (currentRowData.SupplierPrice)
                newData.FXPrice = currentRowData.SupplierPrice;
              else newData.FXPrice = currentRowData.FXPrice;

              newData.SupplierUMQuantity = newData.SupplierReceivedQty;
              newData.FXAmount = getFxLineTotal(
                newData.FXPrice,
                newData.SupplierReceivedQty,
              );

              if (currentRowData.SupplierReceivedQty !== 0) {
                this.SubtractFromGstAmount(
                  this.calculateRowTaxWithQty(
                    { ...newData, ...currentRowData },
                    currentRowData.SupplierReceivedQty,
                  ),
                );
                let prevHeaderTotal = this.calculateHeaderTotalByPrice(
                  parseFloat(
                    currentRowData.SupplierReceivedQty * newData.FXPrice,
                  ).roundNumber(2),
                  this.calculateRowTaxWithQty(
                    { ...newData, ...currentRowData },
                    currentRowData.SupplierReceivedQty,
                  ),
                );
                this.subtractFromHeaderTotal(prevHeaderTotal);
                // this.subtractFromHeaderTotal(
                //   e.previousValue * lineData.data.FXPrice
                // );
              }
              this.AddToGstAmount(
                this.calculateRowTaxWithQty(
                  { ...newData, ...currentRowData },
                  newData.SupplierReceivedQty,
                ),
              );
              let headerTotal = this.calculateHeaderTotalByPrice(
                newData.FXAmount,
                this.calculateRowTaxWithQty(
                  { ...newData, ...currentRowData },
                  newData.SupplierReceivedQty,
                ),
              );
              this.addToHeaderTotal(headerTotal);
              // this.addToHeaderTotal(e.value * lineData.data.FXPrice);
              this.mergeWithReviewView(newData.FXAmount == 0 ? false : true, {
                ...newData,
                ...currentRowData,
              });
            }

            this.GLCodeChanged(value, currentRowData);

            if (
              !currentRowData.ComputedStringCode &&
              currentRowData.IsNewLine != true
            )
              this.GLEntryItems.insert(this.getNewRowDataForGLEntry());

            return newData;
          },
          // showEditorAlways: this.baseView.mode == "create",
        },
        {
          label: "Description",
          dataField: "ItemDescription",
          allowEditing: false,
          allowSearch: this.baseView.mode == "review",
          allowSorting: this.baseView.mode == "review",
          minWidth: ColumnWidth.ProductDescription.minWidth - 20,
        },
      ];

      let taxCodeColumn = [
        {
          screenField: "TaxCode",
          label: "Tax",
          allowSearch: this.dataViewType == "review" ? true : false,
          allowSorting: this.dataViewType == "review" ? true : false,
          allowFiltering: false,
          width: ColumnWidth.TaxCode.width,
          minWidth: ColumnWidth.TaxCode.minWidth,
          makeReadOnly: (data) => {
            if (data.data.ItemType == "S") return true;
            else return this.dataModel.CurrencyCode != "AUD" ? true : false;
          },
          cellTemplate: this.dataViewType == "review" ? "Record" : undefined,
          cssClass: "edit-cell-textbox-field gl-tax-field",
          allowEditing: true,
          lookup:
            this.baseView.mode != "review"
              ? {
                  allowClearing: false,
                  dataSource: this.taxCodeDataSourceItems,
                  displayExpr: "Code",
                  valueExpr: "Code",
                  searchExpr: ["Code", "Description"],
                }
              : undefined,
          editorOptions: {
            itemTemplate: (data) => {
              return ` <div class="custom-auto-complete" id="${data.Code}" >
                  <span class="auto-complete-primary">
                    ${data.Description}
                  </span>
                  <span class="record-secondary gc-grid-code">
                    ${data.Code}
                  </span>
                </div>`;
            },
            dropDownOptions: {
              minWidth: 150,
            },
            onKeyDown: (e, lineData) => {
              this.onEnterItemCode(e, lineData, "BranchCode");
            },
            onSelectionChanged: (e, lineData) => {
              if (lineData.data.TaxCode == e.selectedItem.Code) {
                return;
              } else {
                this.onEnterItemCode(
                  { event: { key: "Enter" } },
                  lineData,
                  "SupplierReceivedQty",
                );

                lineData.data.TaxCode = e.selectedItem.Code;
                lineData.data.TaxPcnt = e.selectedItem.Rate;
                lineData.data.TaxRate = e.selectedItem.Rate;

                // lineData.data.FXAmount = getFxLineTotal(lineData.data.FXPrice, lineData.data.SupplierReceivedQty);
                lineData.data.FXTaxLineTotal = getFXTaxLineTotal(
                  lineData.data.FXAmount,
                  lineData.data.TaxPcnt,
                );
                lineData.data.FXIncTaxLineTotal = getFXIncTaxLineTotal(
                  lineData.data.FXAmount,
                  lineData.data.FXTaxLineTotal,
                );

                this.mergeWithReviewView(true, lineData.data);

                this.CalculateGstAmount();
                this.CalculateHeaderTotal();
              }
            },
          },
          setCellValue: (newData, value) => {
            newData.TaxCode = value;
            return newData;
          },
          showEditorAlways: this.baseView.mode == "create",
        },
      ];

      return columns
        .concat(this.getBranchDivisionColumns)
        .concat([
          {
            screenField: "SalesUM",
            dataField: "SupplierUM",
            allowSearch: false,
            allowSorting: this.dataViewType == "review",
            allowFiltering: false,
            width: ColumnWidth.UnitOfMeasure.width,
            minWidth: ColumnWidth.UnitOfMeasure.minWidth,
          },
        ])
        .concat(taxCodeColumn)
        .concat(this.getCommonColumns)
        .concat([
          {
            caption: "",
            dataField: "",
            type: "buttons",
            buttons: [
              {
                name: "add",
                icon: "add",
                onClick: (e) => {
                  this.addNewRowByPosition(e, "add-line");
                },
              },
              {
                name: "copy",
                icon: "copy",
                onClick: (e) => {
                  this.addNewRowByPosition(e, "copy-line");
                },
              },
              {
                name: "remove",
                icon: "trash",
                onClick: (e) => {
                  this.addNewRowByPosition(e, "remove-line");
                },
              },
            ],
            visible: this.baseView.mode != "review",
            width: 75,
          },
        ]);
    },

    getBranchDivisionColumns() {
      return [
        {
          screenField: "Branch",
          gridDataField: "BranchCode",
          cellTemplate: this.dataViewType == "review" ? "Record" : undefined,
          allowSearch: this.dataViewType == "review",
          allowSorting: this.dataViewType == "review",
          allowFiltering: false,
          required: true,
          width: ColumnWidth.BranchCode.width,
          minWidth: ColumnWidth.BranchCode.minWidth,
          cssClass: "edit-cell-textbox-field",
          allowEditing: true,
          lookup:
            this.baseView.mode != "review"
              ? {
                  allowClearing: false,
                  dataSource: this.branchDataSourceItems,
                  displayExpr: "Code",
                  valueExpr: "Code",
                  searchExpr: ["Code", "Description"],
                }
              : undefined,
          editorOptions: {
            itemTemplate: (data) => {
              return ` <div class="custom-auto-complete" id="${data.Code}" >
                  <span class="auto-complete-primary">
                    ${data.Code}
                  </span>
                  <span class="record-secondary gc-grid-code">
                    ${data.Description}
                  </span>
                </div>`;
            },
            dropDownOptions: {
              minWidth: 250,
            },
            onKeyDown: (e, lineData) => {
              this.onEnterItemCode(e, lineData, "DivisionCode");
              if (this.dataViewType == "product-list")
                this.onReverseTab(e, lineData);
            },
            onItemClick: (e, lineData) => {
              this.onEnterItemCode(
                { event: { key: "Enter" } },
                lineData,
                "DivisionCode",
              );
            },
          },
          setCellValue: (newData, value) => {
            newData.BranchCode = value;
            return newData;
          },
          showEditorAlways: this.baseView.mode == "create",
        },
        {
          screenField: "Division",
          gridDataField: "DivisionCode",
          allowSearch: this.dataViewType == "review",
          allowSorting: this.dataViewType == "review",
          allowFiltering: false,
          width: ColumnWidth.Division.width,
          minWidth: ColumnWidth.Division.minWidth,
          cellTemplate: this.dataViewType == "review" ? "Record" : undefined,
          cssClass: "edit-cell-textbox-field",
          allowEditing: true,
          lookup:
            this.baseView.mode != "review"
              ? {
                  allowClearing: false,
                  dataSource: this.divisionDataSourceItems,
                  displayExpr: "Code",
                  valueExpr: "Code",
                  searchExpr: ["Code", "Description"],
                }
              : undefined,
          editorOptions: {
            itemTemplate: (data) => {
              return ` <div class="custom-auto-complete" id="${data.Code}" >
                  <span class="auto-complete-primary">
                    ${data.Code}
                  </span>
                  <span class="record-secondary gc-grid-code">
                    ${data.Description}
                  </span>
                </div>`;
            },
            dropDownOptions: {
              minWidth: 250,
            },
            onKeyDown: (e, lineData) => {
              if (
                this.dataViewType == "general-ledger" &&
                forwardTabbing(e) &&
                !lineData.data.IsTaxableSupplier
              ) {
                e.event.preventDefault();
                this.focusOnEditableCell(
                  lineData.rowIndex,
                  "SupplierReceivedQty",
                );
              } else {
                this.onEnterItemCode(
                  e,
                  lineData,
                  this.baseView.mode == "create"
                    ? "SupplierReceivedQty"
                    : "SupplierUMQuantity",
                );
              }
            },
            onItemClick: (e, lineData) => {
              this.onEnterItemCode(
                { event: { key: "Enter" } },
                lineData,
                this.baseView.mode == "create"
                  ? "SupplierReceivedQty"
                  : "SupplierUMQuantity",
              );
            },
          },
          setCellValue: (newData, value) => {
            newData.DivisionCode = value;
            return newData;
          },
          showEditorAlways: this.baseView.mode == "create",
        },
      ];
    },
    getCommonColumns() {
      return [
        {
          screenField: "Quantity",
          dataField:
            this.baseView.mode == "create"
              ? "SupplierReceivedQty"
              : "SupplierUMQuantity",
          label: "Invoiced",
          minWidth: ColumnWidth.Quantity4DecimalPoints.minWidth,
          width: ColumnWidth.Quantity4DecimalPoints.width,
          type: "EditableDecimal",
          allowEditing: true,
          showEditorAlways: this.baseView.mode == "create",
          allowFiltering: false,
          allowSearch: false,
          allowSorting: false,
          makeDisabled: (data) => {
            if (
              data.data.IsBatchProduct == "No" ||
              data.data.IsBatchProduct == "Auto"
            ) {
              return false;
            } else return true;
          },
          onKeyDown: (e, lineData) => {
            if (
              this.dataViewType == "general-ledger" &&
              backwardTabbing(e) &&
              !lineData.data.IsTaxableSupplier
            ) {
              e.event.preventDefault();
              this.focusOnEditableCell(lineData.rowIndex, "DivisionCode");
            } else this.onEnterItemCode(e, lineData, "FXPrice");
          },
        },
        {
          screenField: "FXPrice",
          label: "Unit Price (" + this.getCurrencyCode + ")",
          minWidth: ColumnWidth.Quantity4DecimalPoints.minWidth,
          width: ColumnWidth.Quantity4DecimalPoints.width,
          type: "EditableDecimal",
          allowEditing: true,
          showEditorAlways: this.baseView.mode == "create",
          allowFiltering: false,
          allowSearch: false,
          allowSorting: false,
          onKeyDown: (e, lineData) => {
            let nextField = "FXAmount";
            if (forwardTabbing(e)) {
              if (lineData.data.SupplierReceivedQty == 0) {
                e.event.preventDefault();
                nextField = "Comment";
              }
              setTimeout(() => {
                this.focusOnEditableCell(lineData.rowIndex, nextField);
              }, 100);
            } else this.onEnterItemCode(e, lineData, nextField);
          },
          format: "Decimal-16-4",
        },

        {
          screenField: "FXTotal",
          dataField: "FXAmount",
          label: "Ex Total (" + this.getCurrencyCode + ")",
          minWidth: ColumnWidth.Price4DecimalPoints.minWidth,
          width: ColumnWidth.Price4DecimalPoints.width,
          allowFiltering: false,
          allowSearch: false,
          allowSorting: false,
          cellTemplate: false,
          type: "EditableDecimal",
          allowEditing: true,
          showEditorAlways: this.baseView.mode == "create",
          makeDisabled: (data) => {
            if (data.data.SupplierReceivedQty != 0) {
              return false;
            } else return true;
          },
        },
        {
          screenField: "TaxTotal",
          dataField: "FXTaxLineTotal",
          label: "Tax (" + this.getCurrencyCode + ")",
          minWidth: ColumnWidth.TaxFXLineTotal.minWidth,
          width: ColumnWidth.TaxFXLineTotal.width,
          cellTemplate: false,
        },
        {
          screenField: "IncTaxFXTotal",
          dataField: "FXIncTaxLineTotal",
          label: "Inc Total (" + this.getCurrencyCode + ")",
          minWidth: ColumnWidth.Price4DecimalPoints.minWidth,
          width: ColumnWidth.Price4DecimalPoints.width,
          allowEditing: true,
          type: "EditableDecimal",
          showEditorAlways: this.baseView.mode == "create",
          allowFiltering: false,
          allowSearch: false,
          allowSorting: false,
          makeDisabled: (data) => {
            if (data.data.SupplierReceivedQty == 0) {
              return true;
            } else return false;
          },
        },
        {
          screenField: "Comments",
          dataField: "Comment",
          // allowEditing: this.baseView.mode != "review",
          showEditorAlways: this.baseView.mode == "create",
          allowEditing: true,
          allowSearch: false,
          allowSorting: false,
          minWidth: ColumnWidth.Comment.minWidth,
          width: ColumnWidth.Comment.width,
          editCellTemplate: "EditableTextArea",
          onKeyDown: (e, lineData) => {
            if (e.event.key == "Tab" && e.event.shiftKey == true) {
              if (lineData.data.SupplierReceivedQty == 0) {
                e.event.preventDefault();
                setTimeout(() => {
                  this.focusOnEditableCell(lineData.rowIndex, "FXPrice");
                }, 100);
              }
            } else this.onEnterItemCode(e, lineData, "next");
          },
          editorOptions: {
            maxLength: 100,
          },
        },
        // {
        //   screenField: "GridRecordEllipsisMenu",
        //   allowEditing: false,
        //   allowSearch: false,
        //   showInColumnChooser: false,
        //   allowSorting: false,
        //   cssClass: "padding-7",
        // },
      ];
    },
    getReviewColumns() {
      return [
        {
          screenField: "ItemType",
          dataField: this.baseView.mode == "create" ? "LineType" : "ItemType",
          label: "Type",
          minWidth: ColumnWidth.ItemType.width,
          width: ColumnWidth.ItemType.minWidth,
        },
        {
          screenField: "Item",
          label: "Product/Account",
          dataField: "ItemCode",
          gridDataField: "ItemCode",
          sortOrder: "asc",
          sortIndex: this.baseView.mode == "create" ? 0 : 2,
          width: ColumnWidth.ProductOrAccount.width,
          cellTemplateRecord: {
            image: {
              codeDataField: "ItemCode",
              descriptionDataField: "ItemDescription",
              hasPrimaryImageDataField: "HasPrimaryImage",
            },
            primary: [
              {
                dataField: "ItemDescription",
              },
            ],
            secondary: [
              {
                dataField: "ItemCode",
              },
            ],
          },
          exportFields: [
            {
              dataField: "ItemCode",
              label: "Customer Code",
            },
            {
              dataField: "ItemDescription",
              label: "Customer Name",
            },
          ],
          // fixed: true,
          // fixedPosition: "left",
          allowHiding: false,
        },
        {
          screenField: "PurchaseOrder",
          dataField: "PurchaseOrderCode",
          width: ColumnWidth.PurchaseOrderWrap.width,
          minWidth: ColumnWidth.PurchaseOrderWrap.minWidth,
          hyperlink: {
            url: `purchase-order/review/__ID__`,
            dataField: "PurchaseOrderCode",
            target: "_blank",
          },
          sortOrder: this.baseView.mode == "review" ? "asc" : undefined,
          sortIndex: this.baseView.mode == "review" ? 0 : undefined,
        },
        {
          screenField: "GoodsIn",
          dataField: "GoodsInCode",
          // width: "auto",
          width: ColumnWidth.GoodsInCode.width,
          minWidth: ColumnWidth.GoodsInCode.minWidth,
          hyperlink: {
            url: `goods-in-review/review/__ID__`,
            dataField: "GoodsInCode",
            target: "_blank",
          },
          sortOrder: this.baseView.mode == "review" ? "asc" : undefined,
          sortIndex: this.baseView.mode == "review" ? 1 : undefined,
        },
        {
          screenField: "Branch",
          gridDataField: "BranchCode",
          allowSearch: this.dataViewType == "review",
          allowSorting: this.dataViewType == "review",
          // visible: this.baseView.mode == "review",
          width: ColumnWidth.BranchCode.width,
          minWidth: ColumnWidth.BranchCode.minWidth,
          cellTemplate: undefined,
        },
        {
          screenField: "Division",
          gridDataField: "DivisionCode",
          allowSearch: this.dataViewType == "review",
          allowSorting: this.dataViewType == "review",
          // visible: this.baseView.mode == "review",
          width: ColumnWidth.Division.width,
          minWidth: ColumnWidth.Division.minWidth,
          cellTemplate: undefined,
        },
        {
          screenField: "SalesUM",
          dataField: "SupplierUM",
          allowSearch: false,
          allowSorting: this.dataViewType == "review",
          allowFiltering: false,
          width: ColumnWidth.UnitOfMeasure.width,
          minWidth: ColumnWidth.UnitOfMeasure.minWidth,
        },
        {
          screenField: "TaxCode",
          label: "Tax",
          cellTemplateRecord: undefined,
          exportFields: undefined,
          cellTemplate: undefined,
          width: ColumnWidth.TaxCode.width,
        },
        {
          screenField: "Quantity",
          dataField:
            this.baseView.mode == "create"
              ? "SupplierReceivedQty"
              : "SupplierUMQuantity",
          label: "Invoiced",
          minWidth: ColumnWidth.Quantity4DecimalPoints.minWidth,
          width: ColumnWidth.Quantity4DecimalPoints.width,
          // type: "EditableDecimal",
          // showEditorAlways: true,
        },
        {
          screenField: "FXPrice",
          label: "Unit Price (" + this.getCurrencyCode + ")",
          minWidth: ColumnWidth.Quantity4DecimalPoints.minWidth,
          width: ColumnWidth.Price4DecimalPoints.width,
          format: "Decimal-16-4",
          // type: "EditableDecimal",
          // showEditorAlways: true,
        },

        {
          screenField: "FXTotal",
          dataField: "FXAmount",
          label: "Ex Total (" + this.getCurrencyCode + ")",
          minWidth: ColumnWidth.Price4DecimalPoints.minWidth,
          width: ColumnWidth.Price4DecimalPoints.width,
        },
        {
          screenField: "TaxTotal",
          dataField: "FXTaxLineTotal",
          label: "Tax (" + this.getCurrencyCode + ")",
          minWidth: ColumnWidth.TaxFXLineTotal.minWidth,
          width: ColumnWidth.TaxFXLineTotal.width,
          cellTemplate: false,
        },
        {
          screenField: "IncTaxFXTotal",
          dataField: "FXIncTaxLineTotal",
          label: "Inc Total (" + this.getCurrencyCode + ")",
          minWidth: ColumnWidth.Price4DecimalPoints.minWidth,
          width: ColumnWidth.Price4DecimalPoints.width,
        },

        {
          screenField: "Comments",
          dataField: "Comment",
          // allowEditing: this.baseView.mode != "review",
          // showEditorAlways: true,
          allowSearch: false,
          allowSorting: false,
          minWidth: ColumnWidth.Comment.minWidth,
          // editCellTemplate: "EditableTextArea",
        },
      ];
    },
    getCurrencyCode() {
      if (this.dataModel.CurrencyCode) return this.dataModel.CurrencyCode;
      else return this.displayCurrencyCode;
    },
  },
  methods: {
    historyCallBack(data) {
      this.InvoicedAmount = data.FXAmount;
      this.showHistory = true;
    },
    formContentReady(e) {
      const formInstance = e.component;
      if (formInstance) {
        this.$nextTick(() => {
          setTimeout(() => {
            if (formInstance.getEditor("NewInvoiceDate"))
              formInstance.getEditor("NewInvoiceDate").instance().focus();
          }, 400);
        });
      }
    },
    saveImageToFiles(data) {
      this.Attachements = data;
    },
    showAttachmentModel() {
      this.VisibleAttachmentPopup = true;
    },
    async goToSupplierCredit() {
      await this.$router.push({
        path: `/supplier-credit/create/${this.baseView.id}`,
        query: {
          from: "/supplier-invoice/review/" + this.baseView.id,
          SUP_ID: encodeURI(
            JSON.stringify(
              this.$refs["supplier-invoice"].getTransactionData().SupplierCode,
            ),
          ),
        },
      });
    },
    isPriceUpdated(lineData, FxPrice) {
      if (!lineData.PrevFXPrice) {
        lineData.PrevFXPrice = lineData.FXPrice;
      }

      if (FxPrice != lineData.PrevFXPrice) lineData.isPriceUpdated = true;

      return lineData;
    },
    onSupplierSelectionChanged(e) {
      this.SupplierData = e.selectedItem;
    },
    reFocusOnSupField() {
      setTimeout(() => {
        if (
          this.toolBarFormInstance &&
          this.toolBarFormInstance.getEditor("SupplierCode")
        )
          this.toolBarFormInstance.getEditor("SupplierCode").instance().focus();
      }, 250);
    },
    async getGoodsInReceivedList() {
      await SupplierInvoiceService.getCustomData({
        url: "GoodsInDetail",
        filter:
          this.getGoodsInReceivedListFilter() != undefined
            ? this.getGoodsInReceivedListFilter() +
              ` and ReceivedQty ne 0 and Invoiced eq 'N' and Status ne 'C'`
            : "ReceivedQty ne 0 and Invoiced eq 'N' and Status ne 'C'",
        orderby: "PurchaseOrderCode asc",
      })
        .then(async (res) => {
          this.GoodsInReceivedListItems = await this.PostProcess(
            res.data.value,
          );
          // this.GoodsInReceivedListItems = res.data.value;
        })
        .catch((err) => {
          if (err) this.GoodsInReceivedListItems = [];
        });
    },
    getGoodsInReceivedListFilter() {
      if (
        (this.dataModel.PurchaseOrderCode &&
          this.dataModel.PurchaseOrderCode !== "") ||
        (this.isCreateMode() && this.baseView.id)
      ) {
        if (this.dataModel.SupplierCode && this.dataModel.SupplierCode !== "") {
          return `SupplierCode eq '${
            this.dataModel.SupplierCode
          }' and PurchaseOrderCode eq ${parseInt(
            this.dataModel.PurchaseOrderCode,
          )}`;
        } else {
          return `PurchaseOrderCode eq ${parseInt(
            this.dataModel.PurchaseOrderCode,
          )}`;
        }
      } else if (this.baseView.query.SUP_ID) {
        return `SupplierCode eq '${JSON.parse(this.baseView.query.SUP_ID)}'`;
      } else {
        if (this.dataModel.SupplierCode && this.dataModel.SupplierCode !== "") {
          return `SupplierCode eq '${this.dataModel.SupplierCode}'`;
        }
        return undefined;
      }
    },
    async productListDeleteLine(e) {
      let confirmDelete = await this.$confirm(
        "Are you sure you want to delete this line ?",
        "Delete Record",
      );

      if (confirmDelete) {
        var dataRow = { ...e.row.data };
        var index = this.productPurchaseListItems.findIndex(
          (x) => x.ItemCode == dataRow.ItemCode && x.ID == dataRow.ID,
        );
        if (index != -1) {
          this.productPurchaseListItems.splice(index, 1);
        }

        var rIndex = this.findReviewDataSourceIndex(dataRow);

        if (rIndex != -1) {
          this.removeFromReview(rIndex);
        }

        this.CalculateGstAmount();
        this.CalculateHeaderTotal();
      }
    },
    productListCopyLine(e) {
      var dataRow = { ...e.row.data };
      dataRow.FXAmount = 0;
      dataRow.FXIncTaxLineTotal = 0;
      dataRow.FXPrice = 0;
      dataRow.FXTaxLineTotal = 0;
      dataRow.FXTotal = 0;
      dataRow.Price = 0;
      dataRow.SupplierUMQuantity = 0;
      dataRow.SupplierReceivedQty = 0;
      dataRow.ID = new Date().getTime();
      dataRow.RecordId = new Date().getTime();
      dataRow.IsCopy = true;

      this.productPurchaseListItems.push(dataRow);
    },
    onChangeFXAmount() {
      var incTaxTotal = 0;
      this.reviewDataSource.forEach((x) => {
        incTaxTotal += (x.FXAmount + x.FXTaxLineTotal).roundNumber(2);
      });

      var diff = parseFloat((this.dataModel.FXAmount - incTaxTotal).toFixed(2));

      if (Math.abs(diff) <= 0.1) {
        this.dataModel.FXVarianceRounding = diff;
      } else {
        this.dataModel.FXVarianceRounding = 0;
      }
    },
    async onReverseTab(e, cellInfo) {
      if (e.event.keyCode == 9 && e.event.shiftKey) {
        e.component.blur();
        // setTimeout(async () => {
        var rowIndex = cellInfo.rowIndex;
        var headerFormInstance =
          this.$refs["supplier-invoice"].$refs["gc-header-form-component"]
            .$refs["gc-header-form"].$refs["gc-form-comp"].instance;

        if (rowIndex == 0) {
          e.event.preventDefault();
          if (headerFormInstance) {
            headerFormInstance
              .getEditor("FXVarianceRounding")
              .instance()
              .focus();
          }
        } else {
          if (this.dataViewType == "received-list") {
            var dataGrid =
              this.$refs[
                "supplier-invoice"
              ].$refs.transactionGrid.getGridInstance();
            var isPrevLine = dataGrid.getKeyByRowIndex(cellInfo.rowIndex - 1);
            if (isPrevLine) {
              await dataGrid.byKey(isPrevLine).then((res) => {
                if (!res.CheckInclude) {
                  e.event.preventDefault();
                  var prevLine = undefined;
                  for (let index = cellInfo.rowIndex - 2; index >= 0; index--) {
                    isPrevLine = dataGrid.getKeyByRowIndex(index);
                    if (isPrevLine) {
                      dataGrid.byKey(isPrevLine).then((res) => {
                        if (res.CheckInclude) prevLine = index;
                      });
                    }
                    if (prevLine != undefined) break;
                  }

                  if (prevLine != undefined) {
                    var el = dataGrid.getCellElement(prevLine, "Comment");
                    dataGrid.focus(el);
                    setTimeout(() => {
                      el.click();
                    }, 1);
                  } else {
                    if (headerFormInstance) {
                      headerFormInstance
                        .getEditor("FXVarianceRounding")
                        .instance()
                        .focus();
                    }
                  }
                }
              });
            }
          }
        }
        // }, 2);
      } else if (e.event.keyCode == 9) {
        // if (cellInfo.component)
        //   cellInfo.component.editCell(cellInfo.rowIndex, 13);
      }
    },
    onToNextLine(e, cellInfo) {
      if (
        e.event.keyCode == 9 &&
        e.event.shiftKey == false &&
        this.dataViewType == "received-list"
      ) {
        var dataGrid =
          this.$refs[
            "supplier-invoice"
          ].$refs.transactionGrid.getGridInstance();
        var isNextLine = dataGrid.getKeyByRowIndex(cellInfo.rowIndex + 1);
        if (isNextLine) {
          dataGrid.byKey(isNextLine).then((res) => {
            if (!res.CheckInclude) {
              e.event.preventDefault();
              var visibleRows = dataGrid.getVisibleRows();
              var nextLine = undefined;
              for (
                let index = cellInfo.rowIndex + 2;
                index < visibleRows.length;
                index++
              ) {
                isNextLine = dataGrid.getKeyByRowIndex(index);
                if (isNextLine) {
                  dataGrid.byKey(isNextLine).then((res) => {
                    if (res.CheckInclude) nextLine = index;
                  });
                }
                if (nextLine != undefined) break;
              }

              if (nextLine != undefined) {
                var el = dataGrid.getCellElement(nextLine, "FXPrice");
                dataGrid.focus(el);
                setTimeout(() => {
                  el.click();
                }, 1);
              }
            }
          });
        }
      }
    },

    moveOnKeyDown(e) {
      if (e.event.keyCode == 9 && e.event.shiftKey == false) {
        var dataGrid =
          this.$refs[
            "supplier-invoice"
          ].$refs.transactionGrid.getGridInstance();
        if (
          this.dataViewType != "review" &&
          dataGrid.getDataSource().items().length != 0
        ) {
          e.event.preventDefault();
          var rowIndex = 0;
          setTimeout(() => {
            var dataField = undefined;
            if (this.dataViewType == "received-list") {
              rowIndex = dataGrid
                .getDataSource()
                .items()
                .findIndex((x) => x.CheckInclude);
              if (rowIndex != -1) dataField = "FXPrice";
            } else if (this.dataViewType == "product-list") {
              dataField = "BranchCode";
            } else if (this.dataViewType == "general-ledger") {
              dataField = "ComputedStringCode";
            }

            if (dataField) {
              var el = dataGrid.getCellElement(rowIndex, dataField);
              dataGrid.focus(el);
              setTimeout(() => {
                el.click();
              }, 1);
            }
          }, 50);
        }
      }
    },
    onFocusedCellChanged(e) {
      logDev("onFocusedCellChanged", e);
      if (e.column.allowEditing) {
        this.focusOnEditableCell(e.rowIndex, e.column.dataField);
      }
    },
    onHeaderFormContentReady(e) {
      if (this.dataModel.SupplierCode) return;

      setTimeout(() => {
        this.toolBarFormInstance = e.component;

        if (
          this.toolBarFormInstance &&
          this.toolBarFormInstance.getEditor("SupplierCode")
        )
          this.toolBarFormInstance.getEditor("SupplierCode").instance().focus();
      }, 500);
    },
    onFormContentReady(e) {
      if (!this.headerFormInstance) this.headerFormInstance = e.component;
      if (this.baseView.query.SUP_ID && this.headerFormInstance) {
        if (!this.dataModel.PurchaseOrderCode) {
          this.focusHeaderFormItem("PurchaseOrderCode");
        }
      } else if (this.isCreateMode() && this.baseView.id) {
        this.focusHeaderFormItem("DateIn");
      }
    },
    focusHeaderFormItem(fieldName) {
      if (
        this.headerFormInstance &&
        this.headerFormInstance.getEditor(fieldName)
      )
        this.$nextTick(function () {
          this.headerFormInstance.getEditor(fieldName).instance().focus();
        });
    },
    async addNewRowByPosition(e, type) {
      this.validationSummary = [];
      if (!e.row.data.ItemCode && type == "copy-line") {
        this.validationSummary.push({
          message: "Account is required",
        });
      } else {
        if (type == "remove-line") {
          let confirmDelete = await this.$confirm(
            "Are you sure you want to delete this record ?",
            "Delete Record",
          );
          if (confirmDelete) {
            let item = e.row.data;

            this.GLEntryItems._array.splice(e.row.rowIndex, 1);

            var index = this.findReviewDataSourceIndex(item);

            if (index != -1) {
              this.removeFromReview(index);
            }

            this.CalculateGstAmount();
            this.CalculateHeaderTotal();
          }
        } else {
          let dataObj = undefined;

          if (type == "add-line") {
            dataObj = this.getNewRowDataForGLEntry();
          } else {
            dataObj = Object.assign({ ...e.row.data });
            dataObj.LineNo = 0;
            dataObj.SupplierReceivedQty = 0;
            dataObj.FXPrice = 0;
            dataObj.FXAmount = 0;
            dataObj.FXTaxLineTotal = 0;
            dataObj.FXIncTaxLineTotal = 0;
          }

          dataObj.ID = new Date().getTime();
          this.GLEntryItems._array.splice(e.row.rowIndex + 1, 0, dataObj);
        }

        setTimeout(() => {
          this.$refs["supplier-invoice"].$refs["transactionGrid"].$refs[
            "gc-dat-gridtransaction-grid"
          ].instance.refresh();
          this.onEnterItemCode(
            { event: { key: "Enter" } },
            {
              rowIndex: e.row.rowIndex,
            },
            "next",
          );

          if (this.GLEntryItems._array.length == 0) {
            this.GLEntryItems.insert(this.getNewRowDataForGLEntry()).then(
              () => {
                this.onEnterItemCode(
                  { event: { key: "Enter" } },
                  {
                    rowIndex: 0,
                  },
                  "ComputedStringCode",
                );
              },
            );
          }
        }, 250);
      }
    },
    onEditorPreparing(e) {
      if (e.editorOptions && e.editorOptions.onFocusIn) {
        let func = e.editorOptions.onFocusIn;
        if (this.baseView.mode != "review" && e.parentType != "searchPanel")
          e.editorOptions.onFocusIn = (event) => {
            func(event, {
              column: {
                dataField: e.dataField,
              },
              data: e.row.data,
              rowIndex: e.row.rowIndex,
            });
          };
      }
      if (e.editorOptions && e.editorOptions.onKeyDown) {
        let func = e.editorOptions.onKeyDown;
        if (this.baseView.mode != "review" && e.parentType != "searchPanel")
          e.editorOptions.onKeyDown = (event) => {
            func(event, {
              column: {
                dataField: e.dataField,
              },
              data: e.row.data,
              rowIndex: e.row.rowIndex,
            });
          };
      }

      if (e.editorOptions && e.editorOptions.onItemClick) {
        let func = e.editorOptions.onItemClick;
        if (this.baseView.mode != "review" && e.parentType != "searchPanel")
          e.editorOptions.onItemClick = (event) => {
            func(event, {
              column: {
                dataField: e.dataField,
              },
              data: e.row.data,
              rowIndex: e.row.rowIndex,
            });
          };
      }

      if (e.editorOptions && e.editorOptions.onSelectionChanged) {
        let func = e.editorOptions.onSelectionChanged;
        if (this.baseView.mode != "review" && e.parentType != "searchPanel")
          e.editorOptions.onSelectionChanged = (event) => {
            func(event, {
              column: {
                dataField: e.dataField,
              },
              data: e.row.data,
              rowIndex: e.row.rowIndex,
            });
          };
      }

      if (e.dataField == "TaxCode" && this.dataViewType == "general-ledger") {
        if (!e.row.data.IsTaxableSupplier) {
          e.readOnly = true;
          e.allowEditing = false;
          e.lookup = undefined;
          e.showEditorAlways = false;
          e.editorType = undefined;
          e.editorOptions.disabled = true;
        }
      }
    },
    // eslint-disable-next-line no-unused-vars
    onEnterItemCode(e, lineData, nextField) {
      var dataGrid =
        this.$refs["supplier-invoice"].$refs["transactionGrid"].$refs[
          "gc-dat-gridtransaction-grid"
        ].instance;
      var visibleRows = dataGrid.getVisibleRows();

      if (
        lineData.column &&
        lineData.column.dataField == "Comment" &&
        lineData.rowIndex == visibleRows.length - 1
      ) {
        e.event.preventDefault();
        return;
      }

      if (e.event.key == "Enter" && lineData.column) {
        setTimeout(() => {
          this.focusOnEditableCell(
            lineData.rowIndex,
            lineData.column.dataField,
          );
          // this.focusOnEditableCell(lineData.rowIndex, nextField);
        }, 100);
      }
    },
    focusOnEditableCell(rowIndex, col) {
      var columnName = col ? col : "ItemCode";
      var dataGrid =
        this.$refs["supplier-invoice"].$refs["transactionGrid"].$refs[
          "gc-dat-gridtransaction-grid"
        ].instance;

      if (col == "next") {
        if (dataGrid.getKeyByRowIndex(rowIndex + 1)) {
          rowIndex = rowIndex + 1;
          columnName = "ComputedStringCode";
        }
      }

      var cellElement = dataGrid.getCellElement(rowIndex, columnName);
      dataGrid.focus(cellElement);
      setTimeout(() => {
        dataGrid.editCell(rowIndex, columnName);
      }, 10);
    },
    addSelectedGLItems(e) {
      if (e.selectedItem) {
        var index = this.GLItems.findIndex(
          (x) => x.Code == e.selectedItem.Code,
        );
        if (index == -1) this.GLItems.push(e.selectedItem);
      }
    },
    GLCodeChanged(value, currentRowData) {
      var item = this.GLItems.find((x) => x.Code == value);

      if (item)
        this.GLEntryItems.update(currentRowData.ID, {
          ItemDescription: item.Description,
        });
    },
    getNewRowDataForGLEntry() {
      let etaDate = new Date();

      if (this.defaultDataModel.ETADate)
        etaDate = this.defaultDataModel.ETADate;

      var TaxCode = undefined;
      var IsTaxableSupplier = true;

      if (this.SupplierData) {
        if (this.SupplierData.IsTaxableSupplier == "Y") {
          if (this.defaultTaxCode.length > 0) {
            TaxCode = this.defaultTaxCode[0].Code;
          } else {
            TaxCode = "G";
          }
        } else {
          IsTaxableSupplier = false;
          TaxCode = "E";
        }
      } else {
        if (this.defaultTaxCode.length > 0) {
          TaxCode = this.defaultTaxCode[0].Code;
        } else TaxCode = this.dataModel.CurrencyCode == "AUD" ? "G" : "E";
      }

      var TaxPcnt = 0;
      var tax = this.taxCodeDataSourceItems.filter((t) => t.Code == TaxCode);
      if (tax.length > 0) TaxPcnt = tax[0].Rate;

      var rowData = {
        ...glItemBase,
        ID: new Date().getTime(),
        BranchCode: this.defaultDataModel.DefaultBranchCode,
        BranchDescription: this.defaultDataModel.DefaultBranchDescription,
        DivisionCode: this.defaultDataModel.DefaultDivisionCode,
        DivisionDescription: this.defaultDataModel.DefaultDivisionDescription,
        RequiredByDate: new Date(),
        ETADate: etaDate,
        TaxCode: TaxCode,
        TaxPcnt: TaxPcnt,
        IsTaxableSupplier: IsTaxableSupplier,
      };

      return rowData;
    },
    findReviewDataSourceIndex(rowData) {
      var index = -1;
      if (this.dataViewType == "general-ledger") {
        index = this.reviewDataSource.findIndex((i) => i.ID == rowData.ID);
      } else if (this.dataViewType == "received-list") {
        // index = this.reviewDataSource.findIndex((i) => i.ID == rowData.ID);

        index = this.reviewDataSource.findIndex(
          (x) =>
            x.GoodsInCode == rowData.GoodsInCode && x.LineNo == rowData.LineNo,
        );
      } else if (this.dataViewType == "product-list") {
        index = this.reviewDataSource.findIndex((i) => i.ID == rowData.ID);
      } else {
        if (rowData.IsCopy) {
          index = this.reviewDataSource.findIndex(
            (i) =>
              i.ItemType == rowData.ItemType &&
              i.ItemCode == rowData.ItemCode &&
              rowData.IsCopy &&
              rowData.ID == i.ID,
          );
        } else
          index = this.reviewDataSource.findIndex(
            (i) =>
              i.ItemType == rowData.ItemType && i.ItemCode == rowData.ItemCode,
          );
      }
      return index;
    },
    enableLinkAnItem() {
      this.linkAnItem = {
        visible: true,
        popUpCallBack: this.linkAnItemCallback,
        linkAnItemData: this.dataModel,
      };
    },
    linkAnItemCallback(item) {
      if (item) {
        item.SupplierCode = this.dataModel.SupplierCode;
        item.SupplierPrice = 0;
        item.SupplierLead = 0;
        this.productPurchaseListItems.push(item);
        // this.newlyLinkedItems.push(item);
        // let gridRef = this.$refs["supplier-invoice"].$refs["transactionGrid"].gridRef
        // this.$refs["supplier-invoice"].$refs["transactionGrid"].$refs[gridRef].instance.refresh();
      }
      this.linkAnItem = undefined;
    },
    calculateHeaderTotalByPrice(amount, tax) {
      return amount + tax;
    },
    calculateRowTaxWithTax(row) {
      let totalTax = getFXTaxLineTotal(row.FXAmount, row.TaxPcnt);
      return totalTax;
    },
    clearInvoiceNo() {
      this.dataModel.InvoiceNo = "";
    },
    AddToGstAmount(value) {
      this.dataModel.GstAmount += value;
    },
    CalculateHeaderTotal() {
      // let fxAmountTotal = 0;
      // let gstAmountTotal = 0;
      // // logDev("CalculateHeaderTotal");
      // this.reviewDataSource.forEach((x) => {
      //   fxAmountTotal += x.FXAmount;
      //   gstAmountTotal += x.FXTaxLineTotal ? x.FXTaxLineTotal : 0;
      // });
      // logDev("fxAmountTotal , gstAmountTotal", fxAmountTotal, gstAmountTotal);
      // this.dataModel.FXAmount = fxAmountTotal + gstAmountTotal;
    },
    CalculateGstAmount() {
      let gstAmountTotal = 0;
      this.reviewDataSource.forEach(
        (x) => (gstAmountTotal += x.FXTaxLineTotal ? x.FXTaxLineTotal : 0),
      );
      this.dataModel.GstAmount = gstAmountTotal.roundNumber(2);
    },
    addToHeaderTotal(value) {
      this.dataModel.FXAmount += value;
    },
    subtractFromHeaderTotal(value) {
      this.dataModel.FXAmount -= value;
    },
    SubtractFromGstAmount(value) {
      this.dataModel.GstAmount -= value;
    },
    isNavigatedWithSupplier() {
      return this.baseView.query.SUP_ID;
    },
    isCreateMode() {
      return this.baseView.mode === "create";
    },
    isReviewMode() {
      return this.baseView.mode === "review";
    },
    isNavigatedWithPurchaseOrder() {
      return this.baseView.id;
    },
    renderHeaderForm() {
      this.$refs["supplier-invoice"].$refs["gc-header-form-component"].$refs[
        "gc-header-form"
      ].formRepaint();
    },
    calculateRowTaxWithQty(row, qty) {
      let taxRate = row.TaxPcnt == undefined ? row.TaxRate : row.TaxPcnt;

      let totalTax = getFXTaxLineTotal(row.FXAmount, taxRate);

      return qty ? totalTax : 0;
    },
    // calculateRowTax(row, price = 0) {

    //   if (this.dataViewType == "received-list") {
    //     let taxPercent = row.TaxRate !== 0 ? row.TaxRate / 100 : 0;
    //     let fxPrice =
    //       price === 0 ? row.Price.roundNumber(2) : price.roundNumber(2);

    //     return parseFloat(
    //       parseFloat(fxPrice * row.SupplierReceivedQty).roundNumber(2) *
    //         taxPercent
    //     ).roundNumber(2);
    //   } else {
    //     let taxRate = row.TaxPcnt == undefined ? row.TaxRate : row.TaxPcnt;

    //     let taxPercent = taxRate !== 0 ? taxRate / 100 : 0;

    //     let fxPrice =
    //       price === 0 ? row.Price.roundNumber(2) : price.roundNumber(2);

    //     return parseFloat(
    //       parseFloat(row.SupplierReceivedQty * fxPrice).roundNumber(2) *
    //         taxPercent
    //     ).roundNumber(2);
    //   }
    // },
    getPurchaseOrdersBySupplierCode(supplierCode) {
      SupplierInvoiceService.getPurchaseOrdersBySupplierCode(supplierCode).then(
        ({ data: elements }) => {
          elements.sort((a, b) => {
            return a.PurchaseOrderCode - b.PurchaseOrderCode;
          });

          elements.forEach((element) => {
            element.Code = element.PurchaseOrderCode;
          });
          this.PurchaseOrders = elements;
        },
      );
    },
    getProductPurchaseList(supplierCode, setFocus) {
      this.productPurchaseListItems = [];
      ProductService.getProductPurchaseList(
        `SupplierCode eq '${supplierCode}' and IsBatchProduct eq 'No'`,
        {
          select: [
            "PurchaseDescription1",
            "ProductCode",
            "ProductDescription1",
            "RecordId",
            "SupplierConversion",
            "SupplierUM",
            "SupplierPrice",
            "IsBatchProduct",
            "ItemType",
            "SupplierCode",
            "TaxCode",
            "TaxPcnt",
            "LandedCostFactor",
          ],
        },
      ).then((res) => {
        res.data.value.forEach((element) => {
          if (this.SupplierData && this.SupplierData.IsTaxableSupplier == "N") {
            element.TaxCode = "E";
            element.TaxPcnt = 0;
          }
        });
        this.productPurchaseListItems = res.data.value;

        if (setFocus) {
          this.reFocusOnSupField();
        }
      });
    },
    getReceivedViewGridFilter() {
      if (
        (this.dataModel.PurchaseOrderCode &&
          this.dataModel.PurchaseOrderCode !== "") ||
        (this.isCreateMode() && this.baseView.id)
      ) {
        if (this.dataModel.SupplierCode && this.dataModel.SupplierCode !== "") {
          return [
            ["SupplierCode", "=", this.dataModel.SupplierCode],
            "and",
            [
              "PurchaseOrderCode",
              "=",
              parseInt(this.dataModel.PurchaseOrderCode),
            ],
          ];
        } else
          return [
            "PurchaseOrderCode",
            "=",
            parseInt(this.dataModel.PurchaseOrderCode),
          ];
      } else if (this.baseView.query.SUP_ID) {
        return [
          ["SupplierCode", "=", JSON.parse(this.baseView.query.SUP_ID)],
          "and",
          [["ReceivedQty", "<>", 0]],
          "and",
          ["Invoiced", "=", "N"],
        ];
      } else {
        if (this.dataModel.SupplierCode && this.dataModel.SupplierCode !== "") {
          return ["SupplierCode", "=", `${this.dataModel.SupplierCode}`];
        }
        return undefined;
      }
    },
    onPurchaseOrderValueChanged() {
      // this.$store.dispatch(
      //   "dataContext/updateDataChangedIndex",
      //   this.dataChangedIndex++
      // );

      if (this.dataViewType !== "received-list") {
        this.$store.dispatch("dataContext/setDataViewType", "received-list");
      }
      // this.$refs["supplier-invoice"].$refs[
      //   "transactionGrid"
      // ].instance.refresh();
      // this.renderHeaderForm();
      this.$store.dispatch("dataContext/setDataViewType", "received-list");
    },
    async onActionDetele(e, lineData, lineParent) {
      let confirmDelete = await this.$confirm(
        "Are you sure you want to delete this record?",
        "Delete",
      );

      if (confirmDelete && e) {
        lineParent.data.SupplierReceivedQty -=
          lineData.data.SupplierBatchReceivedQty;
        lineParent.data.Completed =
          lineParent.data.SupplierReceivedQty >=
          lineParent.data.SupplierOutstandingQuantity;

        lineParent.data.FXAmount = (
          lineParent.data.FXPrice * lineParent.data.SupplierReceivedQty
        ).roundNumber(2);
        lineParent.data.ChildDataSource.splice(lineData.rowIndex, 1);
        if (lineParent.data.ChildDataSource.length == 0) {
          lineParent.data.ChildDataSource.push({
            BatchNo: "",
            SupplierBatchNo: "",
            SupplierCode: "",
            UseByDate: null,
            SupplierBatchReceivedQty: 0,
            ActualStockConversion: lineParent.data.SupplierConversion,
            ReceivedQty: lineParent.data.SupplierReceivedQty,
          });
        }

        if (lineParent.data.FXAmount == 0) {
          var index = this.findReviewDataSourceIndex(lineParent.data);

          if (index != -1) {
            this.removeFromReview(index);
          }
        }
      }
    },
    async RetrieveSupplierData(supplierCode) {
      let supplierResponse = await SupplierService.getByCode(supplierCode, {
        select: [
          "DefaultBranchCode",
          "WetApplicable",
          "TermCalculation",
          "Terms",
          "Name",
          "Code",
          "CurrencyCode",
          "IsTaxableSupplier",
        ],
      });

      if (supplierResponse.data.value.length == 0)
        alert(
          `Supplier Data could not be retrieved for code ${supplierCode}. Please try again.`,
        );

      return supplierResponse.data.value[0];
    },
    async onSupplierClick(Code) {
      if (this.SupplierData && this.SupplierData.Code != Code)
        this.SupplierData = await this.RetrieveSupplierData(Code);

      this.dataModel.Supplier = this.SupplierData;
      this.dataModel.PayeeName = this.SupplierData.Name;

      if (this.SupplierData.CurrencyCode != this.dataModel.CurrencyCode) {
        this.dataModel.CurrencyCode = this.SupplierData.CurrencyCode;
        this.refreshColumns = new Date().getTime();
      } else {
        // this.$refs["supplier-invoice"].$refs["gc-header-form-component"].$refs[
        //   "gc-header-form"
        // ].formRepaint();
      }

      let result = await CompanyCurrencyService.getByCurrencyCode(
        this.dataModel.CurrencyCode,
        {
          select: ["SellRate"],
        },
      );

      if (result.data.value.length == 0) this.dataModel.ExchangeRate = 1;
      else this.dataModel.ExchangeRate = result.data.value[0].SellRate;

      if (this.SupplierData.DefaultBranchCode) {
        this.defaultDataModel.DefaultBranchCode =
          this.SupplierData.DefaultBranchCode;
      } else if (getDefaultUserSettings().BranchCode) {
        this.defaultDataModel.DefaultBranchCode =
          getDefaultUserSettings().BranchCode;
      } else {
        SupplierService.getDefault().then(({ data }) => {
          this.defaultDataModel.DefaultBranchCode = data.value[0].BranchCode;
        });
      }

      if (this.dataViewType != "received-list") {
        this.$store.dispatch("dataContext/setDataViewType", "received-list");
      }

      this.updateDueDate({
        value: this.dataModel.InvoiceDate,
      });

      this.$refs["supplier-invoice"].$refs["gc-header-form-component"].$refs[
        "gc-header-form"
      ].formRepaint();
    },
    onChangeFXFreight() {
      this.$store.dispatch(
        "dataContext/updateDataChangedIndex",
        this.dataChangedIndex++,
      );
    },
    onChangeGstAmount() {
      this.$store.dispatch(
        "dataContext/updateDataChangedIndex",
        this.dataChangedIndex++,
      );
    },
    async saveSupplierInvoice(dataModel) {
      this.validationSummary = [];

      var total = 0;
      this.reviewDataSource.forEach((element) => {
        // total += element.FXIncTaxLineTotal.roundNumber(2);
        total += (element.FXAmount + element.FXTaxLineTotal).roundNumber(2);
      });
      let balance =
        this.dataModel.FXAmount - (total + this.dataModel.FXVarianceRounding);

      // headerData.FXAmount - (total + headerData.FXVarianceRounding)

      if (balance.roundNumber(2) !== 0) {
        this.validationSummary.push({
          message: "The Supplier Invoice is not balanced",
        });
      } else if (
        this.getPayLoad(dataModel).SupplierInvoiceDetails.length == 0
      ) {
        this.validationSummary.push({
          message: "No line item has been selected",
        });
      } else {
        this.setLoading = true;
        let savePayload = this.getPayLoad(dataModel);

        let notGLLines = savePayload.SupplierInvoiceDetails.filter(
          (x) => x.ItemType != "G",
        );

        let fxPriceUpdatedLines = [];
        if (notGLLines.length > 0) {
          fxPriceUpdatedLines = this.reviewDataSource.filter(
            (x) => x.isPriceUpdated && x.ItemType != "G",
          );
        }

        var updateSupPrice = "N";
        if (
          notGLLines.length > 0 &&
          getFactorByCode(661).Factorc.toLowerCase() == "y" &&
          fxPriceUpdatedLines.length > 0
        ) {
          let confirmPriceChange = await this.$confirm(
            "Do you wish to update the Supplier Prices for products using the prices in this Invoice ?",
            "Update the Supplier Prices",
          );

          if (confirmPriceChange) updateSupPrice = "Y";
        }
        savePayload.UpdateSupplierPriceWithInvoicePrice = updateSupPrice;

        await SupplierInvoiceService.saveSupplierInvoice(savePayload)
          .then((res) => {
            this.setLoading = false;

            this.$notify(
              `Supplier Invoice ${res.data.Code} Successfully Saved`,
              "success",
            );

            this.reload = true;
            this.loaded = false;

            this.setIgnoreRouteChangeConfirmation();
            this.$router
              .push({
                path: `/supplier-invoice/review/${res.data.Code}`,
              })
              .then(() => {
                this.$store.dispatch("dataContext/setDataViewType", "review");
                this.$store.dispatch("dataContext/setReviewDataSource", []);
                this.initialized();
              });
          })
          .catch((err) => {
            if (err) this.setLoading = false;
            this.serverError = {
              err: err,
              msg: "Supplier Invoice Save Failed",
              time: new Date().getTime(),
            };
          });
      }
    },
    checkBoxValueChange(fieldData, recordData) {
      if (!fieldData.event) return;
      var dataGrid =
        this.$refs["supplier-invoice"].$refs["transactionGrid"].$refs[
          "gc-dat-gridtransaction-grid"
        ].instance;
      var gridItems = [];
      if (this.dataViewType == "received-list") {
        gridItems = this.GoodsInReceivedListItems;
      } else if (this.dataViewType == "product-list") {
        gridItems = this.productPurchaseListItems;
      } else if (this.dataViewType == "general-ledger") {
        gridItems = this.GLEntryItems._array;
      } else {
        gridItems = this.reviewDataSource;
      }

      if (recordData.rowType == "header") {
        if (fieldData.value == undefined) return;
        else {
          let includeRecord = fieldData.value;
          gridItems.forEach((element) => {
            element.CheckInclude = includeRecord;
            var data = undefined;
            if (element.CheckInclude) {
              element.SupplierReceivedQty = element.ReceivedQty;
              data = this.calcTotals(element, true);
            } else data = this.calcTotals(element, false);
            element = data[0];
            this.mergeWithReviewView(includeRecord, element);
          });
        }
      } else {
        let includeRecord = fieldData.value;
        if (this.dataViewType == "received-list") {
          var data = undefined;
          recordData.data.SupplierReceivedQty = recordData.data.ReceivedQty;
          if (includeRecord) data = this.calcTotals(recordData.data, true);
          else data = this.calcTotals(recordData.data, false);

          recordData.data = data[0];
        }
        recordData.data.CheckInclude = includeRecord;
        this.mergeWithReviewView(includeRecord, recordData.data);
      }

      this.CalculateGstAmount();
      this.CalculateHeaderTotal();

      this.renderHeaderForm();

      this.updateHeaderCheckBox(gridItems);
      if (!this.baseView.id) {
        // finding number of po selected
        let isMultiplePo = true;
        let selectedItems = gridItems.filter(
          (gridItem) => gridItem.CheckInclude,
        );
        if (selectedItems.length > 0) {
          let po = selectedItems[0].PurchaseOrderCode;
          selectedItems.forEach((selectedItem) => {
            if (selectedItem.PurchaseOrderCode != po) {
              isMultiplePo = true;
            } else {
              isMultiplePo = false;
            }
          });

          if (!isMultiplePo) {
            this.showLoading = true;
            PurchaseOrder.getByCode(po).then(({ data: purchaseOrder }) => {
              if (purchaseOrder.value[0].B2BSupplierReferenceNo) {
                this.dataModel.InvoiceNo =
                  purchaseOrder.value[0].B2BSupplierReferenceNo;
                this.renderHeaderForm();
              }
              this.showLoading = false;
            });
          } else {
            this.dataModel.InvoiceNo = undefined;
          }
        } else {
          this.dataModel.InvoiceNo = undefined;
        }
      }

      setTimeout(() => {
        var dataField = "FXPrice";
        // if (this.dataViewType == "received-list") {
        //   dataField = "SupplierReceivedQty";
        // }

        let cellElement = dataGrid.getCellElement(
          recordData.rowIndex,
          dataField,
        );
        dataGrid.focus(cellElement);
        dataGrid.editCell(recordData.rowIndex, dataField);
      }, 1000);

      // this.$refs["supplier-invoice"].$refs["transactionGrid"].gridRepaint();
    },
    calcTotals(element, recalc) {
      if (!recalc) {
        element.SupplierReceivedQty = 0;
        element["CheckInclude"] = false;
        element.FXPrice = JSON.parse(JSON.stringify(element.OriginalFXPrice));
      }

      element.FXAmount = getFxLineTotal(
        element.FXPrice,
        element.SupplierReceivedQty,
      );
      element.FXTaxLineTotal = getFXTaxLineTotal(
        element.FXAmount,
        element.TaxPcnt,
      );
      element.FXIncTaxLineTotal = getFXIncTaxLineTotal(
        element.FXAmount,
        element.FXTaxLineTotal,
      );

      setTimeout(() => {
        this.updateHeaderCheckBox([element]);
      }, 500);

      return [element];
    },

    updateHeaderCheckBox(gridItems) {
      if (
        !this.$refs["supplier-invoice"] ||
        !this.$refs["supplier-invoice"].$refs["transactionGrid"] ||
        !this.$refs["supplier-invoice"].$refs["transactionGrid"].$refs[
          "cx-CheckInclude"
        ]
      )
        return;

      var refHeadInstance =
        this.$refs["supplier-invoice"].$refs["transactionGrid"].$refs[
          "cx-CheckInclude"
        ].getSeletcAllRef().instance;
      var checkBoxHeader = refHeadInstance.element();
      var getInstanceHeader = CheckBox.getInstance(checkBoxHeader);
      let count = 0;
      gridItems.forEach((element) => {
        if (element.CheckInclude) {
          count = count + 1;
        }
      });

      setTimeout(() => {
        if (count > 0 && count != gridItems.length) {
          getInstanceHeader.option("value", undefined);
        } else if (count == 0) {
          getInstanceHeader.option("value", false);
        } else if (count == gridItems.length) {
          getInstanceHeader.option("value", true);
        }
      }, 100);
    },

    calculateDueDate(dateValue, termConfig) {
      const date = new Date(dateValue);
      const year = date.getFullYear();
      const month = date.getMonth();
      const { TermCalculation, Terms } = termConfig;

      if (TermCalculation === "ACTUAL") {
        return new Date(dateValue).addDays(Terms);
      } else if (TermCalculation === "EOM" && Terms % 30 === 0) {
        return new Date(year, month + Terms / 30 + 1, 0);
      } else if (TermCalculation === "SPLIT") {
        const calculatedDate = new Date(dateValue);
        return calculatedDate.getDate() <= 15
          ? new Date(
              calculatedDate.getFullYear(),
              calculatedDate.getMonth() + 1,
              0,
            )
          : new Date(
              calculatedDate.getFullYear(),
              calculatedDate.getMonth() + 1,
              15,
            );
      } else {
        return new Date(year, month + 1, 0).addDays(Terms);
      }
    },

    updateDueDateFromModel(e) {
      if (!this.UpdateDueDateModel || !e.event) return;

      this.InvoiceDate = e.value;
      this.UpdateDueDateModel.NewDueDate = this.calculateDueDate(
        e.value,
        this.UpdateDueDateModel,
      );
      this.newDueDate = true;
    },

    updateDueDate(e) {
      if (!this.SupplierData) return;

      this.DueDateMin = e.value;
      this.dataModel.DueDate = this.calculateDueDate(
        e.value,
        this.SupplierData,
      );
    },
    async initialized() {
      this.setLoading = true;
      if (this.baseView.mode == "create") {
        if (getFactorByCode(470).Factorc.toLowerCase() == "y") {
          this.isInvoiceNoRequired = true;
        }
        this.dataModel.PurchaseOrderCode = this.baseView.id;
        this.InvoiceDate = new Date();
        this.setDateInValidation();
        await this.setBranchDataSourceItems();
        await this.setDivisionDataSourceItems();
        await this.setTaxCodeDataSourceItems();

        if (getDefaultUserSettings().BranchCode) {
          this.defaultDataModel.DefaultBranchCode = this.dataModel.BranchCode =
            getDefaultUserSettings().BranchCode;
        } else {
          await BranchService.getDefault({
            select: ["Code", "Description"],
          }).then((res) => {
            this.defaultDataModel.DefaultBranchCode =
              this.dataModel.BranchCode = res.data.value[0].Code;
            this.defaultDataModel.DefaultBranchDescription =
              res.data.value[0].Description;
          });
        }

        if (getDefaultUserSettings().DivisionCode) {
          this.defaultDataModel.DefaultDivisionCode =
            this.dataModel.DivisionCode = getDefaultUserSettings().DivisionCode;
        } else {
          await DivisionService.getDefault({
            select: ["Code", "Description"],
          }).then((res) => {
            this.defaultDataModel.DefaultDivisionCode =
              this.dataModel.DivisionCode = res.data.value[0].Code;
            this.defaultDataModel.DefaultDivisionDescription =
              res.data.value[0].Description;
          });
        }

        if (!this.defaultDataModel.DefaultBranchDescription) {
          let resBranch = await BranchService.getByCode(
            this.defaultDataModel.DefaultBranchCode,
            {
              select: ["Code", "Description"],
            },
          );
          this.defaultDataModel.DefaultBranchDescription =
            resBranch.data.value[0].Description;

          // this.setDeliverTo(this.model, {
          //   itemData: resBranch.data.value[0],
          // });
        }

        if (!this.defaultDataModel.DefaultDivisionDescription) {
          let resDivision = await DivisionService.getByCode(
            this.defaultDataModel.DefaultDivisionCode,
            {
              select: ["Code", "Description"],
            },
          );
          this.defaultDataModel.DefaultDivisionDescription =
            resDivision.data.value[0].Description;
        }

        if (this.baseView.id) {
          // this.dataModel.PurchaseOrderCode = this.baseView.id;
          await PurchaseOrder.getByCode(this.baseView.id, {
            select: [
              "Code",
              "CurrencyCode",
              "SupplierCode",
              "B2BSupplierReferenceNo",
            ],
          })
            .then(async (res) => {
              var data = res.data.value[0];
              this.dataModel.CurrencyCode = data.CurrencyCode;
              // this.dataModel = data;
              this.dataModel["PurchaseOrder"] = data.Code;
              this.dataModel["SupplierCode"] = data.SupplierCode;
              this.dataModel["Supplier"] = data.Supplier;
              this.dataModel["SupplierName"] = data.Supplier.Name;
              this.dataModel["PayeeName"] = data.Supplier.Name;
              this.dataModel["DateIn"] = new Date();
              this.SupplierData = data.Supplier;
              this.dataModel["DueDate"] = undefined;
              this.dataModel["InvoiceNo"] = data.B2BSupplierReferenceNo;
              this.dataModel["InvoiceDate"] = new Date();

              this.dataModel["FXFreight"] = 0;
              this.dataModel["GstAmount"] = 0;
              this.dataModel["FXAmount"] = 0;
              let result = await CompanyCurrencyService.getByCurrencyCode(
                this.dataModel.CurrencyCode,
                {
                  select: ["SellRate", "CurrencyCode"],
                },
              );
              if (data.Supplier.DefaultBranchCode) {
                this.defaultDataModel.DefaultBranchCode =
                  data.Supplier.DefaultBranchCode;
              }
              this.dataModel.ExchangeRate = result.data.value[0].SellRate;
              this.getProductPurchaseList(data.Supplier.Code);
              this.getPurchaseOrdersBySupplierCode(data.Supplier.Code);
              setTimeout(() => {
                this.$store.dispatch(
                  "dataContext/setDataViewType",
                  "received-list",
                );
              }, 500);
              this.dataModel.PurchaseOrderCode = this.baseView.id;
              this.loaded = true;
              this.setLoading = false;
            })
            .catch((err) => {
              this.loaded = true;
              this.setLoading = false;
              if (err)
                this.serverError = {
                  err: err,
                  msg: "PO Not Found",
                  time: new Date().getTime(),
                };
            });
          this.updateDueDate({ value: new Date() });
        } else {
          if (this.baseView.query) {
            if (this.baseView.query.SUP_ID) {
              this.getProductPurchaseList(
                JSON.parse(this.baseView.query.SUP_ID),
              );
              this.getPurchaseOrdersBySupplierCode(
                JSON.parse(this.baseView.query.SUP_ID),
              );

              this.SupplierData = await this.RetrieveSupplierData(
                JSON.parse(this.baseView.query.SUP_ID),
              );

              this.dataModel.Supplier = this.SupplierData;
              this.dataModel.SupplierName = this.SupplierData.Name;
              this.dataModel.SupplierCode = this.SupplierData.Code;
              this.dataModel.PayeeName = this.SupplierData.Name;
              this.dataModel.CurrencyCode = this.SupplierData.CurrencyCode;
              this.dataModel.DateIn = new Date();
              this.dataModel.DueDate = undefined;
              this.dataModel.InvoiceNo = undefined;

              this.dataModel.FXFreight = 0;
              this.dataModel.GstAmount = 0;
              this.dataModel.FXAmount = 0;

              if (this.SupplierData.DefaultBranchCode) {
                this.defaultDataModel.DefaultBranchCode =
                  this.SupplierData.DefaultBranchCode;
              }
              let result = await CompanyCurrencyService.getByCurrencyCode(
                this.dataModel.CurrencyCode,
                {
                  select: ["SellRate", "CurrencyCode"],
                },
              );
              this.dataModel.ExchangeRate = result.data.value[0].SellRate;
              this.loaded = true;
              this.setLoading = false;

              // calculate the due date when the supplier is given
              this.updateDueDate({ value: new Date() });
            } else {
              await CompanyService.getByCompanyCode(
                getFactorByCode(18).Factorc,
                {
                  select: ["CurrencyCode"],
                },
              ).then((res) => {
                this.dataModel.CurrencyCode = res.data.value[0].CurrencyCode;
              });
              this.loaded = true;
              this.setLoading = false;
            }
          } else {
            this.loaded = true;
            this.setLoading = false;
          }
        }

        if (this.dataModel.SupplierCode) await this.getGoodsInReceivedList();

        this.GLEntryItems.insert(this.getNewRowDataForGLEntry());
      } else {
        await this.getDetailRecord()
          .then((res) => {
            if (res.data.value.length > 0) {
              let pocode = res.data.value[0].PurchaseOrderCode;
              let isPocodeDifferent;
              res.data.value.forEach((item, index) => {
                item.ID = index;
                if (item.PurchaseOrderCode != pocode) isPocodeDifferent = true;
                this.addToReview(item);
              });
              if (isPocodeDifferent) {
                this.isMultiplePurchaseOrders = true;
              } else {
                this.dataModel.PurchaseOrderCode = pocode;
              }
              this.reload = false;
              this.loaded = true;
            }
          })
          .catch((err) => {
            this.serverError = {
              err: err,
              msg: "Supplier Invoice Not Found",
              time: new Date().getTime(),
            };
            this.reload = false;
            this.loaded = true;
          });
        await this.getAttachedFiles();
        this.setLoading = false;
      }
    },
    async InvoiceNoExistsRuleCallback(params) {
      if (!this.dataModel.SupplierCode) {
        this.validationSummary = [];
        this.validationSummary.push({
          message: "Select a Supplier First!",
        });
        this.dataModel.InvoiceNo = "";
        return;
      } else {
        this.focusHeaderFormItem("InvoiceDate");
      }
      this.setLoading = true;
      this.focusHeaderFormItem("InvoiceDate");
      await SupplierInvoiceService.getCustomData({
        url: "SupplierInvoice",
        filter: `SupplierCode eq '${
          this.dataModel.SupplierCode
        }' and InvoiceNo eq '${encodeURIComponent(params.value)}'`,
        select: ["Code"],
      })
        .then((response) => {
          this.setLoading = false;
          if (response.data.value.length > 0) {
            this.warningSummary = [];
            this.warningSummary.push({
              title: "Duplicate Invoice Number",
              message:
                "A duplicate invoice number for this supplier already exists",
            });
            // this.dataModel.InvoiceNo = "";
            setTimeout(() => {
              this.focusHeaderFormItem("InvoiceNo");
            }, 10);
          } else {
            setTimeout(() => {
              this.focusHeaderFormItem("InvoiceDate");
            }, 10);
          }
        })
        .catch((err) => {
          if (err) this.setLoading = false;
          this.focusHeaderFormItem("InvoiceDate");
        });
    },
    goToPay(id) {
      this.$router.push({
        path: `/supplier-payment/create/${id}`,
        query: {
          from: "/supplier-invoice/review/" + this.baseView.id,
          SUP_ID: encodeURI(
            JSON.stringify(
              this.$refs["supplier-invoice"].getTransactionData().SupplierCode,
            ),
          ),
        },
      });
    },
    async onGcPopUpUpdate(e) {
      this.gcPopupCallBack();
      var payload = this.getDuedateUpdatePayload(e);

      this.setLoading = true;
      await SupplierInvoiceService.saveSupplierInvoiceDueDate(payload)
        .then((res) => {
          if (res) this.setLoading = false;

          this.$notify(
            `Supplier Invoice #${res.data.Code} Due Date Successfully Updated`,
            "success",
          );
          e.DueDate = res.data.DueDate;

          this.$refs["supplier-invoice"].$refs[
            "gc-header-form-component"
          ].$refs["gc-header-form"].setFormFiledData(
            "DueDate",
            res.data.DueDate,
          );
          // update InvoiceDate field
          this.$refs["supplier-invoice"].$refs[
            "gc-header-form-component"
          ].$refs["gc-header-form"].setFormFiledData(
            "InvoiceDate",
            res.data.InvoiceDate,
          );
        })
        .catch((err) => {
          this.setLoading = false;
          this.serverError = {
            err: err,
            msg: "Update Failed.",
            time: new Date().getTime(),
          };
        });
    },
    getDuedateUpdatePayload(e) {
      var data = { ...e };

      var payload = {
        Code: data.Code,
        DueDate: new Date(data.NewDueDate).toSaveDate(),
        InvoiceDate: new Date(data.NewInvoiceDate).toSaveDate(),
      };

      return payload;
    },
    getPayLoad(dataModel) {
      var data = { ...dataModel };

      if (data.NewDueDate) {
        data.DueDate = data.NewDueDate;
        delete data.NewDueDate;
      }

      var payload = {
        Code: undefined,
        CurrencyCode: data.CurrencyCode,
        DateIn: data.DateIn.toSaveDate(),
        DueDate: data.DueDate.toSaveDate(),
        ExchangeRate: data.ExchangeRate,
        FXAmount: data.FXAmount,
        FXFreight: data.FXFreight,
        GstAmount: data.GstAmount,
        InvoiceDate: data.InvoiceDate.toSaveDate(),
        InvoiceNo: data.InvoiceNo,
        SupplierCode: data.SupplierCode,
        SupplierInvoiceDetails: [],
        SupplierIsWetApplicable: data.Supplier.WetApplicable,
        TermCalculation: data.Supplier.TermCalculation,
        Terms: data.Supplier.Terms,
        PurchaseOrderCode: data.PurchaseOrder ? data.PurchaseOrder : 0,
        Rounding: data.FXVarianceRounding,
        SupplierName: data.PayeeName,
        TransactionMediaMetas: [],
      };

      this.reviewDataSource.forEach((x) => {
        if (x.CheckInclude) {
          var item = {
            BranchCode: x.BranchCode,
            Comment: x.Comment,
            DivisionCode: x.DivisionCode,
            FXAmount: x.FXAmount,
            GLWorkOrderCode: x.WorkOrderCode,
            GoodsInCode: x.GoodsInCode === "" ? 0 : x.GoodsInCode,
            GoodsInLineNo: x.LineNo,
            ItemCode: x.ItemCode,
            // ItemDescription: x.ItemDescription,
            ItemType: x.LineType,
            LandedCostFactor: x.LandedCostFactor,
            SupplierUMQuantity: x.SupplierUMQuantity,
            WetLineTotal: x.WETLineTotal,
            WorkOrderItemCode: "",
            UM: x.SupplierUM,
            TaxCode: x.TaxCode,
            // RequiredQty: x.Quantity * x.SupplierConversion,
            SupplierConversion: x.SupplierConversion,
            SupplierRequired: x.SupplierUMQuantity,
            FXPrice: x.FXPrice,
            SupplierInvoiceProductBatches: [],
            FXIncTaxLineTotal: x.FXIncTaxLineTotal,
          };

          if (item.GoodsInCode == 0) {
            // this transaction contains new invoice lines that are not associated to any Purchase Order/GoodsIn
            payload.PurchaseOrderCode = 0;
          }

          if (x.ChildDataSource) {
            x.ChildDataSource.forEach((i) => {
              let objBatch = {
                ActualStockConversion: i.ActualStockConversion,
                BatchNo: i.BatchNo,
                Comment: x.Comment,
                ReceivedQty: i.SupplierBatchReceivedQty,
                SupplierBatchNo: i.SupplierBatchNo,
                SupplierReceivedQty: i.SupplierBatchReceivedQty,
                UseByDate: i.UseByDate ? i.UseByDate.toSaveDate() : i.UseByDate,
              };
              item.SupplierInvoiceProductBatches.push(objBatch);
            });
          } else {
            delete item.SupplierInvoiceProductBatches;
          }
          payload.SupplierInvoiceDetails.push(item);
        }
      });

      if (this.Attachements.length > 0) {
        payload.TransactionMediaMetas = this.Attachements.map((file) => ({
          TransactionRecordId: "00000000-0000-0000-0000-000000000000",
          TransactionType: "SupplierInvoice",
          ContentType: file.type,
          FileName: file.name,
          FileSize: file.fileSize,
          MediaBase64String: file.base64,
          RecordId: "00000000-0000-0000-0000-000000000000",
        }));
      }

      return payload;
    },
    visibleGcPopUp() {
      this.gcPopupVisible = true;
    },
    onChangeNewDueDate(e) {
      this.newDueDate = e;

      // do the post call and chek whethere the given date is bw the resulted date.
    },
    supplierInvoicePostProcess(data) {
      if (this.baseView.mode == "review") {
        data["NewInvoiceDate"] = data["InvoiceDate"];
        data["NewDueDate"] = data["DueDate"];
        data.Status = data.FriendlyStatus;
        this.status = data.Status;
        this.InvoiceDate = data.InvoiceDate;

        this.displayCurrencyCode = data.CurrencyCode;
        if (this.isMultiplePurchaseOrders) {
          data.PurchaseOrderCode = "Multiple";
        } else {
          data.PurchaseOrderCode = this.dataModel.PurchaseOrderCode;
        }
        data["FXVarianceRounding"] = data.Rounding;
        this.dataModel.PurchaseOrderLinked = data.PurchaseOrderLinked;
      } else if (this.baseView.mode == "create" && this.baseView.id) {
        data.PurchaseOrderCode = this.baseView.id;
      }
      this.setDateInValidation();
      this.UpdateDueDateModel = { ...this.UpdateDueDateModel, ...data };
      return data;
    },
    PostProcess(data, recalc) {
      if (this.baseView.mode == "create") {
        var items = [];
        data.forEach((element) => {
          if (!element.ID) element.ID = element.RecordId.toString();

          element.TaxPcnt = element.TaxRate;

          element["ReceivedQty"] = element.SupplierReceivedQty;

          if (!recalc) {
            element.SupplierReceivedQty = 0;
            element["CheckInclude"] = false;
          }
          if (element["PurchaseDescription"]) {
            element.ItemDescription = element.PurchaseDescription;
          }
          if (!element["FXAmount"]) element["FXAmount"] = 0;
          if (!element["SupplierUMQuantity"])
            element["SupplierUMQuantity"] = element.SupplierReceivedQty;
          if (!element["GstAmount"]) element["GstAmount"] = 0;
          if (!element["FXTotal"]) element["FXTotal"] = 0;
          if (!element["SupplierConversion"])
            element["SupplierConversion"] = element.StandardStockConversion;

          element.FXPrice = (
            element.FXPrice * element.SupplierConversion
          ).roundNumber(4);

          if (!element["OriginalFXPrice"])
            element["OriginalFXPrice"] = element.FXPrice;

          if (!element["FXFreight"]) element["FXFreight"] = 0;

          element.FXAmount = getFxLineTotal(
            element.FXPrice,
            element.SupplierReceivedQty,
          );
          element.FXTaxLineTotal = getFXTaxLineTotal(
            element.FXAmount,
            element.TaxPcnt,
          );
          element.FXIncTaxLineTotal = getFXIncTaxLineTotal(
            element.FXAmount,
            element.FXTaxLineTotal,
          );

          var index = this.findReviewDataSourceIndex(element);

          if (index == -1) {
            items.push(element);
          } else {
            items.push(this.reviewDataSource[index]);
          }
        });

        setTimeout(() => {
          this.updateHeaderCheckBox(items);
        }, 500);

        return items;
      } else {
        return data;
      }
    },
    GoodsInReceivedListPostProcess(data) {
      setTimeout(() => {
        this.updateHeaderCheckBox(data);
      }, 500);

      return data;
    },
    gcPopupCallBack() {
      this.newDueDate = undefined;
      this.gcPopupVisible = false;
    },
    async setDateInValidation() {
      var currentInvoiceDate = undefined;
      if (this.baseView.mode == "review")
        currentInvoiceDate = new Date(this.InvoiceDate.replace("Z", ""));
      else currentInvoiceDate = this.InvoiceDate;

      let startDateResult =
        await SupplierInvoiceService.getActiveAccountingPeriodStartDate();
      if (startDateResult) {
        let accountingPeriod = new Date(
          startDateResult.data.value[0].StartDate.replace("Z", ""),
        );

        if (
          this.baseView.mode == "review" &&
          currentInvoiceDate.getTime() > accountingPeriod.getTime()
        ) {
          this.InvoiceDate = currentInvoiceDate;
        } else {
          this.InvoiceDate = accountingPeriod;
        }
      } else {
        this.InvoiceDate = currentInvoiceDate;
      }

      let endDateResult =
        await SupplierInvoiceService.getActiveAccountingPeriodEndDate();
      if (endDateResult) {
        let accountingPeriod = endDateResult.data.value[0].EndDate;
        this.InvoiceMaxDate = new Date(accountingPeriod.replace("Z", ""));
      }
    },
    async getDetailRecord() {
      return await SupplierInvoiceDetailsService.getByCode(this.baseView.id);
    },
    addToReview(item) {
      item.CheckInclude = true;
      if (this.isCreateMode()) {
        item.SupplierUMQuantity = item.SupplierReceivedQty;
      }

      // check if item has LandedCostFactor property, if not, set it from PurchaseProductList
      if (!item.hasOwnProperty("LandedCostFactor")) {
        let purchaseProduct = this.productPurchaseListItems.find(
          (p) => p.ProductCode === item.ItemCode,
        );
        if (purchaseProduct) {
          item.LandedCostFactor = purchaseProduct.LandedCostFactor;
        }
      }

      this.reviewDataSource.push(item);
      this.$store.dispatch(
        "dataContext/setReviewDataSource",
        this.reviewDataSource,
      );
    },
    removeFromReview(index) {
      this.reviewDataSource.splice(index, 1);
      this.$store.dispatch(
        "dataContext/setReviewDataSource",
        this.reviewDataSource,
      );
    },
    mergeWithReviewView(mergeRecord, item) {
      var index = this.findReviewDataSourceIndex(item);

      if (!mergeRecord) {
        if (index != -1) {
          this.removeFromReview(index);
        }
      } else {
        if (index != -1) {
          this.removeFromReview(index);
        }
        this.addToReview(item);
        // this.setLineNo();
      }

      this.onChangeFXAmount();
    },
    // setLineNo() {
    //   const maxLineNo = Math.max.apply(
    //     Math,
    //     this.reviewDataSource.map(function (o) {
    //       return o.LineNo;
    //     })
    //   );

    //   this.reviewDataSource[this.reviewDataSource.length - 1].LineNo =
    //     maxLineNo + 1;
    //   this.reviewDataSource[
    //     this.reviewDataSource.length - 1
    //   ].isNewRecord = true;
    // },
    async setDivisionDataSourceItems() {
      let divisionDS = DivisionService.dataSourceConfig("api/Division", {
        filter: [["Inactive", "=", "N"]],
        sort: [{ selector: "Code", asc: false }],
        select: ["Code", "Description", "Inactive"],
        preventPagination: true,
      });

      this.divisionDataSourceItems = await divisionDS.load();
    },
    async setBranchDataSourceItems() {
      let branchDS = BranchService.dataSourceConfig("api/Branch", {
        filter: [["Inactive", "=", "N"]],
        sort: [{ selector: "Code", asc: false }],
        select: ["Code", "Description", "Inactive"],
        preventPagination: true,
      });

      this.branchDataSourceItems = await branchDS.load();
    },
    async setTaxCodeDataSourceItems() {
      let taxCodeDS = TaxCategoryService.dataSourceConfig("api/Tax", {
        filter: [["Inactive", "=", "N"]],
        sort: [{ selector: "Code", asc: false }],
        select: ["Code", "Description", "Inactive", "Rate", "IsDefault"],
        preventPagination: true,
      });

      this.taxCodeDataSourceItems = await taxCodeDS.load();
      this.defaultTaxCode = this.taxCodeDataSourceItems.filter(
        (x) => x.IsDefault == "Y",
      );
    },
    ProductPostProcess(data) {
      // this.newlyLinkedItems.forEach((x) => {
      //   data.push({
      //     ...x,
      //   });
      // });
      var items = [];
      data.forEach((x) => {
        if (!x.ID) x.ID = x.RecordId;
        if (!x.IsDefaultValues) {
          x.ProductDescription1 = x.PurchaseDescription1;
          x.BranchCode = this.defaultDataModel.DefaultBranchCode;
          x.BranchDescription = this.defaultDataModel.DefaultBranchDescription;
          x.DivisionCode = this.defaultDataModel.DefaultDivisionCode;
          x.DivisionDescription =
            this.defaultDataModel.DefaultDivisionDescription;

          x.ItemCode = x.ProductCode;
          x.ItemDescription = x.ProductDescription1;
          x.Code = x.ProductCode;
          x.Description = x.ProductDescription1;

          x.ItemType = "S";
          x.LineType = "S";
          x.FXTotal = 0;
          x.SupplierUMQuantity = 0;
          x.FXPrice = 0;
          x.FXAmount = 0;
          x.SupplierReceivedQty = 0;
          x.GoodsInCode = "";
          x.LineNo = 0;
          x.FXTaxLineTotal = 0;
          x.FXIncTaxLineTotal = 0;

          if (x.IsBatchProduct == "NextNo") {
            // element["GoodsInProductBatches"] = [];
            x["ChildDataSource"] = [
              {
                BatchNo: "",
                SupplierBatchNo: "",
                SupplierCode: "",
                UseByDate: null,
                SupplierBatchReceivedQty: 0,
                ActualStockConversion: x.SupplierConversion,
                ReceivedQty: x.SupplierReceivedQty,
              },
            ];
          } else {
            if (x.IsBatchProduct == "Manual") {
              // element["GoodsInProductBatches"] = [];
              x["ChildDataSource"] = [
                {
                  BatchNo: "",
                  SupplierBatchNo: "",
                  SupplierCode: "",
                  UseByDate: null,
                  SupplierBatchReceivedQty: 0,
                  ActualStockConversion: x.SupplierConversion,
                  ReceivedQty: x.SupplierReceivedQty,
                },
              ];
            }
          }
          x.IsDefaultValues = true;
        }

        var index = this.findReviewDataSourceIndex(x);

        if (index == -1) {
          items.push(x);
        } else {
          items.push(this.reviewDataSource[index]);
        }
      });
      return items;
    },
    GLChartPostProcess(data) {
      logDev("GLChartPostProcess");
      var items = [];

      data.forEach((x) => {
        var index = this.findReviewDataSourceIndex(x);

        if (index == -1) {
          items.push(x);
        } else {
          items.push(this.reviewDataSource[index]);
        }
      });

      // if (this.searchText) items = items.filter(this.filterFunction);
      return items;
    },

    async getAttachedFiles() {
      this.Attachements = [];

      await this.$nextTick();
      // Logic to retrieve attached files

      try {
        const supInv = await SupplierInvoiceService.getByCode(
          this.baseView.id,
          {
            select: ["Code", "RecordId"],
          },
        );

        if (supInv && supInv.data.value.length > 0) {
          const recordId = supInv.data.value[0].RecordId;
          this.transactionRecordId = recordId;
          const attachements = await SupplierInvoiceService.getAttachedFiles(
            recordId,
          );

          if (attachements && attachements.data.value.length > 0) {
            this.Attachements = attachements.data.value.map((file) => {
              const nameIndex = file.FileName.indexOf("_");
              return {
                name: file.FileName.substring(nameIndex + 1),
                type: file.ContentType,
                base64: undefined,
                fileSize: file.FileSize,
                MediaUrl: file.MediaUrl,
                RecordId: file.RecordId,
                DownloadApiUrl: `${appConfig.VUE_APP_ROOT_API}/api/TransactionMedia/${file.BlobName}/download`,
                date: new Date(file.DateCreated).toShortDateString(),
                TransactionRecordID: file.TransactionRecordID,
                TransactionType: file.TransactionType,
              };
            });
          } else {
            this.Attachements = [];
          }
        } else {
          this.Attachements = [];
        }
      } catch (error) {
        this.serverError = {
          err: error,
          msg: "Failed to retrieve attached files.",
          time: new Date().getTime(),
        };
      }
    },
  },
};
</script>
<style lang="scss">
.toolbar-form-items {
  display: flex;
  flex-direction: column;
  justify-content: space-between;
}

.account-editable-field[role="gridcell"] {
  .dx-texteditor .dx-placeholder::before {
    padding-right: unset !important;
    padding-left: unset !important;
  }
}

.dx-row.dx-data-row.dx-row-lines:not(.dx-freespace-row)
  .account-editable-field::after {
  content: "";
  display: block;
  border-bottom: 1px solid #0000006b;
  margin-top: -1px; /* Adjust this value to position the underline properly */
}

.gl-tax-field {
  .dx-textbox.dx-texteditor.dx-editor-underlined.dx-selectbox.dx-state-disabled {
    opacity: unset;
    border-bottom: 0px solid rgba(0, 0, 0, 0.42) !important;
    .dx-texteditor-buttons-container {
      display: none;
    }
  }
}
</style>
